// translations.js
const translations = {
  en: {
    welcome: "Welcome to Quotey!",
    signupInstruction:
      "In order to complete the sign-up process, you will need to agree to Quotey's Terms of Use and set-up a confidential password",
    termsHeading: "Terms and Conditions of Use",
    agreeButton: "I agree to these Terms & Conditions of Use",

    modalTitle: "Mark as complete?",
    modalDescription: "Do you want to mark this reminder or task as complete?",
    followUpText: "Do you want Quotey to set a reminder for you to check-in with the client?",
    followUpTitle: "Chase client for application completion",
    certificateDownloading: "Certificate downloading.....",
    certificateCreated: "Certificate created",

    autoReminderText: "Do you want Quotey to send a reminder for you to check on the insurer’s response?",
    autoReminderTitle: "Check underwriter confirmation of indication.",
    certificateDownloadOptions: "Certificate Download Options",
    importanceIconTooltipGeneral: "This question is generally essential in the market.",
    importanceIconTooltipFor: "This question is essential for: {insurerNames}",
     // Fallback text when no second-level text is provided
     locationFallback: "Location",
     // Label for Delete icons
     deleteLabel: "Delete",
     // Button text for adding a property (building)
     addPropertyButton: "Add Property",
     // Modal texts for removing a property (building)
     removePropertyModalTitle: "Remove Property",
     removePropertyModalBody: "Are you sure you want to remove this property?",
     // Button text for modal actions
     cancelButton: "Cancel",
     deleteButton: "Delete",
     // Default building title prefix when no custom title is set
     defaultBuildingTitlePrefix: "Property #",
    uploadDocumentsTitle: "Upload Additional Documents with Email",
    createEmailButtonText: "Create email with application",
    quoteComparisonToastMessage: "You can select and compare up to {maxQuotes} quotes in the client presentation. This is to ensure your client gets a crisp and clear presentation without cramming too much on a page. Please select the three most relevant quotes and try again.",
        // Modal Titles
        emailDownloadedTitle: "Email Downloaded",
        emailSentToInsurerTitle: "Email Sent to Insurer",
        // Modal Body Messages (Email Modal)
        emailSentForIndication:"An email has been sent to the insurer asking them to firm up the indication provided. Once bindable terms received, you can bind this quote in Quotey",
        emailSentForConfirmation: "An email has been sent to the insurer for them to firm up and confirm the bind. The policy is not bound until confirmed by the insurer.",
        emailSentWithDetails: "An email has been sent to the insurer, with a copy to yourself, with the bind details. The policy is now bound.",
        manualQuoteEmailInstruction: "As this quote was generated outside of Quotey, you will need to send this email to the insurer in order to bind. A bind email has been generated in your downloads to make this easy. Just click to open this email, adjust as necessary and send.",
        approvedCasualtyLegalMessage: "Email has been sent to your inbox, the bind and invoice have been attached.",
        // Common Buttons and Reminder
        closeButton: "Close",
        reminderText: "Do you want Quotey to send a reminder for you to check on receipt of policy",
        reminderTitle: "Check in for policy documents",
        reminderCategory: "Await policy documents",
        
        // Bind Failed Modal
        bindFailedTitle: "Bind Failed",
        bindFailedIssue: "We encountered an issue while attempting to bind your policy.",
        bindFailedRetry: "Please try binding again. If the problem persists, contact support for assistance.",
        bindFailedNotCompleted: "Quotey has been made aware of this bind failure. The bind has not been completed.",
    fileDownloadNotification: "A file is downloaded on left side of the screen",
    bindRequestNotification: "A bind request has been created and downloaded to your screen. Please send this to the insurer to request the bind. Please note - policies are not bound until confirmed by the insurer",
    toastTranslation:"An email is being automatically downloaded. You will see it on the bottom left of your screen as a downloaded file and can click to open it, review, add comments if necessary and send. If your computer asks for permission to download this file please grant it access and 'keep' the file.",
    required: "Required",
    notRequired: "Not Required",
    notIncluded: "Not Included",
    included: "Included",
    reminderText:
      "Do you want Quotey to set a reminder for you to check on insurer responses?",
    reminderTitle: "Check insurer responses.",
    reminderCategory: "Check for quotes",
    pdfDownloadedToast:
      "An PDF is being automatically downloaded. You will see it on the bottom left of your screen as a downloaded file.",
    buttonToast:
      "We are making our best to make this button do what it is suppose to do -- till then enjoy the first option - Generate text based email",
    alertSelectOne: "please select one insurer before make bind request.",
    alertSelectOnlyOne: "please select only one insurer for bind request.",
    actionsDropdown: {
      fees: "Fees",
      addBrokerFee: "Add a Broker Fee",
      // Dropdown button title and options
      title: "Actions",
      editQuote: "Edit Quote",
      bindQuote: "Bind Quote",
      firmUpAndBindQuote: "Firm up Quote",
      referToInsurer: "Refer to Insurer",
      viewQuote: "View Quote",
      info: "Info",
      downloadInsurerDocument: "Download Insurer Document",
      // Popover (Bind Modal) static texts
      bindConfirmationHeader: "Bind Confirmation",
      bindConfirmationText:
        "As terms were originally provided as an indication, please confirm bindable terms from underwriter:",
      finalPremiumQuoted: "Final Premium quoted:",
      insurerFees: "Insurer Fees:",
      totalPremiumFees: "Total Premium & Fees:",
      underwriterName: "Underwriter name",
      underwriterEmail: "Underwriter email",
      dateConfirmedByUnderwriter: "Date confirmed by underwriter",
      // Bind modal additional texts
      editCoveragesQuestion: "Do you need to edit originally quoted coverages?",
      radioYes: "Yes",
      radioNo: "No",
      editCoveragesExplanation:
        "When you click the proceed button, you will first be taken to Edit coverages. Once complete, you can go back to the Digital Marketing Hub and bind.",
      proceedButton: "Proceed",
      // Alert messages (toast)
      alertSelectOne: "please select one insurer before make bind request.",
      alertSelectOnlyOne: "please select only one insurer for bind request.",
      // Email body texts (if used elsewhere)
      emailSubject: "Your insurance application",
      emailBody: `<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Application Invitation</title>
  <style>
    body {
      font-family: Arial, sans-serif;
    }
    .email-container {
      width: 100%;
      max-width: 600px;
    }
    .centered-table {
      width: 100%;
      text-align: center;
    }
    .button {
      display: inline-block;
      background-color: #007bff;
      color: #ffffff;
      text-decoration: none;
      padding: 12px 20px;
      font-size: 16px;
      border-radius: 5px;
      font-weight: bold;
    }
  </style>
</head>
<body>
  <table class="email-container" cellpadding="0" cellspacing="0">
    <tr>
      <td>
        <p>Hi {clientName},</p>
        <p>
          As discussed, here is a link where you can complete all of the relevant information
          in order for us to help you go to our carriers to bring back options.
        </p>
        <p>
          <a href="{link}" class="button">Click here to complete your application online</a>
        </p>
        <p>
          I will be automatically notified when you're done and can move forward with our process.
        </p>
        <p>
          If you have any questions, please let me know. <br />
          I look forward to getting this process started for you.
        </p>
        <p>
          Thank You, <br />
          {brokerName}
        </p>
      </td>
    </tr>
  </table>
</body>`,
    },
    inlineFeesForm: {
      brokerFeeLabel: "Broker Fee:",
      premiumLabel: "Premium:",
      insurerFeeLabel: "Insurer Fee:",
      totalPremiumFeesLabel: "Total Premium & Fees:",
      doneButton: "Done",
      // The placeholder will be generated dynamically based on covers value;
      // you can use a default placeholder if needed:
      brokerFeePlaceholder: "$0",
    },
    chsModal: {
      full: "Full",
      turbo: "Turbo",
      handoffHeader: "Hand-off to Client",
      instructionText:
        "This will create a unique link for your client to complete the application in their own time. You will be notified by email and on Quotey when they are done.",
      sectionsIncludeQuestion:
        "Which sections of the application do you want to include?",
      includeAll: "Include All",
      includeSpecific: "Include specific sections only as selected:",
      shortenedApplicationQuestion:
        "Do you want the client to see the shortened Turbo Application?",
      emailOrLinkQuestion:
        "Do you want Quotey to create an email including the link that you can send, or provide a link you can copy and paste into your own email",
      email: "Email",
      link: "Link",
      finish: "Finish",
      // These keys are used when setting an auto reminder after closing the modal:
      reminderText:
        "Do you want Quotey to set a reminder for you to check-in with the client?",
      reminderTitle: "Chase client for application completion",
      reminderCategory: "Chase hand-off",
      // Email content:
      emailSubject: "Your insurance application",
      emailBody: `<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Application Invitation</title>
  <style>
    body {
      font-family: Arial, sans-serif;
    }
    .email-container {
      width: 100%;
      max-width: 600px;
    }
    .centered-table {
      width: 100%;
      text-align: center;
    }
    .button {
      display: inline-block;
      background-color: #007bff;
      color: #ffffff;
      text-decoration: none;
      padding: 12px 20px;
      font-size: 16px;
      border-radius: 5px;
      font-weight: bold;
    }
  </style>
</head>
<body>
  <table class="email-container" cellpadding="0" cellspacing="0">
    <tr>
      <td>
        <p>Hi {clientName},</p>
        <p>
          As discussed, here is a link where you can complete all of the relevant information
          in order for us to help you go to our carriers to bring back options.
        </p>
        <p>
          <a href="{link}" class="button">Click here to complete your application online</a>
        </p>
        <p>
          I will be automatically notified when you're done and can move forward with our process.
        </p>
        <p>
          If you have any questions, please let me know. <br />
          I look forward to getting this process started for you.
        </p>
        <p>
          Thank You, <br />
          {brokerName}
        </p>
      </td>
    </tr>
  </table>
</body>`,
    },
    ChsSignoffModal: {
      chsButtontxt: "Confirm and Sign",
      chsHeading: "Application Signature and Consent",
      chsElectronicApplicationNotice:
        "On receipt of your consent, an electronically signed insurance application will be created for our records and a copy will be shared with you",
      chsConsentElectronicDisclosures:
        "I consent to Electronic Disclosures and Signature",
      chsViewFullDisclosure: "View Full Disclosure Statement",
      chsESignatureAgreementText:
        'You acknowledge signing this Agreement electronically. By signing this document electronically, you consent to the legally binding terms and conditions of this Agreement. You further agree that your signature on this document (hereafter referred to as your "E-Signature") is as valid as if you signed the document by hand. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature, and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature or any resulting agreement between you and Quotey. You confirm you are authorized to enter into this Agreement',
      chsConsentCreditScore:
        "I consent to use of credit score by insurers in the process of obtaining insurance",
      chsCreditInfoConsentDetails:
        "If you permit an insurer to obtain your credit information, you agree to any such insurer collecting, using and disclosing: (a) the personal information contained in your credit report (that may contain information about your credit standing, credit worthiness, credit capacity, and your credit based insurance score) for the purposes of assessing, offering, underwriting and managing any insurance products offered to you, investigating and settling insurance claims, detecting and preventing insurance fraud and improving our services; and (b) your name and address, date of birth and telephone number to a credit reporting agency for the purpose of obtaining credit information about you. You agree an insurer may disclose your credit information to third-parties reasonably connected to relevant insurance information and offers provided to you, including credit reporting agencies, regulatory bodies, and an insurer’s affiliates. Such disclosures may occur for the purposes of obtaining current or future credit reports relevant to maintaining, updating or renewing your insurance policies. You can revoke your consent at any time by informing your insurance broker. I am authorized to sign on behalf of all named insureds on my policy",
      chsConfirmAccuracy:
        "I confirm the accuracy of information in this application is correct",
      chsInsurerRelianceText:
        "Insurers will rely upon each and every response given in this application in deciding whether or not to offer you insurance products and each product's premiums, terms and conditions. Insurers regard every response to be material to their decisions. Insurers reserve the right to invalidate or repudiate your policies if you provide inaccurate or incomplete information. You agree to promptly inform your insurance broker if the information provided in this application becomes inaccurate or outdated. Completing and signing this application does not bind your organization to purchase any insurance product, nor does it bind the insurer to issue any insurance product. I declare I am authorized to represent my organization in this transaction and the statements set forth in this application are true, complete and accurate. I acknowledge and agree that failure to provide true, complete and accurate information in this application may result in the voiding of any insurance issued in reliance on this application and / or denial of claims under any policy issued",
      chsAuthorizedIndividual: "Name of authorized individual",
      chsRoleWithinBusiness: "Role within the business (if relevant)",
    },
    GtmModal: {
      gtmGoToMarket: "Go To Market",
      gtmUnansweredQuestionsList: "Unanswered Questions List",
      gtmUnansweredQuestionsDescription:
        'The following are a list of important questions that have not been answered. This might impact your ability to receive instant, accurate quotes from insurers. If you click on the relevant question you will be taken directly to it in order to add an answer. If you\'re comfortable with the information provided, you can bypass by clicking "Go To Market"',
      gtmDoNotShowAgain: "Do not show this message again for this prospect",
    },
    ChsModalO: {
      confirmAndSign: "Confirm and Sign",
      applicationSignatureAndConsent: "Application Signature and Consent",
      electronicApplicationNotice:
        "On receipt of your consent, an electronically signed insurance application will be created for our records and a copy will be shared with you",
      consentToElectronicDisclosuresAndSignature:
        "I consent to Electronic Disclosures and Signature",
      viewFullDisclosureStatement: "View Full Disclosure Statement",
      eSignatureAgreementText:
        'You acknowledge signing this Agreement electronically. By signing this document electronically, you consent to the legally binding terms and conditions of this Agreement. You further agree that your signature on this document (hereafter referred to as your "E-Signature") is as valid as if you signed the document by hand. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature, and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature or any resulting agreement between you and Quotey. You confirm you are authorized to enter into this Agreement',
      consentToUseCreditScore:
        "I consent to use of credit score by insurers in the process of obtaining insurance",
      creditInfoConsentDetails:
        "If you permit an insurer to obtain your credit information, you agree to any such insurer collecting, using and disclosing: (a) the personal information contained in your credit report (that may contain information about your credit standing, credit worthiness, credit capacity, and your credit based insurance score) for the purposes of assessing, offering, underwriting and managing any insurance products offered to you, investigating and settling insurance claims, detecting and preventing insurance fraud and improving our services; and (b) your name and address, date of birth and telephone number to a credit reporting agency for the purpose of obtaining credit information about you. You agree an insurer may disclose your credit information to third-parties reasonably connected to relevant insurance information and offers provided to you, including credit reporting agencies, regulatory bodies, and an insurer’s affiliates. Such disclosures may occur for the purposes of obtaining current or future credit reports relevant to maintaining, updating or renewing your insurance policies. You can revoke your consent at any time by informing your insurance broker. I am authorized to sign on behalf of all named insureds on my policy",
      confirmAccuracyOfInformation:
        "I confirm the accuracy of information in this application is correct",
      nameOfAuthorizedIndividual: "Name of authorized individual",
      roleWithinBusiness: "Role within the business (if relevant)",
    },
    reminderModal: {
      setReminderOrTask: "Set a Reminder or Task",
      quoteyReminderQuestion:
        "Do you want Quotey to set a reminder or task for this client?",
      yes: "Yes",
      no: "No",
      reminderTitle: "Reminder Title",
      titlePlaceholder: "Title",
      category: "Category",
      client: "Client",
      clientsLabel: "Clients",
      targetDate: "Target Date",
      ownerType: "Owner Type",
      me: "Me",
      otherPeople: "Other People",
      team: "Team",
      owner: "Owner",
      description: "Description",
      status: "Status",
      statusOpen: "open",
      statusCompleted: "completed",
      statusOnHold: "onhold",
      statusOther: "other",
      sendEmailNotificationToOwner: "Send email notification to owner?",
      updateReminder: "Update Reminder",
      createReminder: "Create Reminder",
    },
    addLocation: "Add Location",
    clientHandOffAgreeText: {
      viewFullDisclosureStatement: "View Full Disclosure Statement",
      electronicSignatureAcknowledgement:
        'You acknowledge signing this Agreement electronically. By signing this document electronically, you consent to the legally binding terms and conditions of this Agreement. You further agree that your signature on this document (hereafter referred to as your "E-Signature") is as valid as if you signed the document by hand. You also agree that no certification authority or other third party verification is necessary to validate your E-Signature, and that the lack of such certification or third party verification will not in any way affect the enforceability of your E-Signature or any resulting agreement between you and Quotey. You confirm you are authorized to enter into this Agreement.',
      creditScoreConsent:
        "I consent to use of credit score by insurers in the process of obtaining insurance",
      creditInformationDisclosure:
        "If you permit an insurer to obtain your credit information, you agree to any such insurer collecting, using and disclosing: (a) the personal information contained in your credit report (that may contain information about your credit standing, credit worthiness, credit capacity, and your credit based insurance score) for the purposes of assessing, offering, underwriting and managing any insurance products offered to you, investigating and settling insurance claims, detecting and preventing insurance fraud and improving our services; and (b) your name and address, date of birth and telephone number to a credit reporting agency for the purpose of obtaining credit information about you. You agree an insurer may disclose your credit information to third-parties reasonably connected to relevant insurance information and offers provided to you, including credit reporting agencies, regulatory bodies, and an insurer’s affiliates. Such disclosures may occur for the purposes of obtaining current or future credit reports relevant to maintaining, updating or renewing your insurance policies. You can revoke your consent at any time by informing your insurance broker. I am authorized to sign on behalf of all named insureds on my policy",
      informationAccuracyConfirmation:
        "I confirm the accuracy of information in this application is correct",
      applicationInformationReliance:
        "Insurers will rely upon each and every response given in this application in deciding whether or not to offer you insurance products and each product's premiums, terms and conditions. Insurers regard every response to be material to their decisions. Insurers reserve the right to invalidate or repudiate your policies if you provide inaccurate or incomplete information. You agree to promptly inform your insurance broker if the information provided in this application becomes inaccurate or outdated. Completing and signing this application does not bind your organization to purchase any insurance product, nor does it bind the insurer to issue any insurance product. I declare I am authorized to represent my organization in this transaction and the statements set forth in this application are true, complete and accurate. I acknowledge and agree that failure to provide true, complete and accurate information in this application may result in the voiding of any insurance issued in reliance on this application and / or denial of claims under any policy issued.",
      nameOfAuthorizedIndividual: "Name of authorized individual",
      roleWithinTheBusiness: "Role within the business (if relevant)",
      onReceiptOfYourConsent:
        "On receipt of your consent, an electronically signed insurance application will be created for our records and a copy will be shared with you",
      iConsentToElectronicDisclosuresAndSignature:
        "I consent to Electronic Disclosures and Signature",
      iConsentToUseOfCreditScore:
        "I consent to use of credit score by insurers in the process of obtaining insurance",
      iConfirmTheAccuracyOfInformation:
        "I confirm the accuracy of information in this application is correct",
      applicationSignatureAndConsent: "Application Signature and Consent",
      confirmAndSign: "Confirm and Sign",
    },

    close: "Close",
    clientAnswerLog: "Client answer log",
    viewChanges: "View Changes",
    clientLogTable: {
      question: "Question",
      oldAnswer: "Old Answer",
      newAnswer: "New Answer",
    },
    essentialQuestion: "This question is Essential. It has importance score of",
    pressEnterToExecute: "Press Enter to execute search",
    pressEnterToSearch: "Press Enter to search",
    outOf5: "out of 5",

    email: "E-mail",
    name: "Name",
    incorrectUsernamePassword: "Incorrect username or password!",
    emailAddressPlaceholder: "Email Address",
    passwordPlaceholder: "Password",
    rememberMeLabel: "Remember Me",
    forgotPasswordLink: "Forgot Password?",
    loginButton: "Login",
    dontHaveAccount: "Don't have an account?",
    signUpLink: "Sign Up",

    // Authentication loading messages
    authentication: {
      authenticating: "Authenticating...",
      verifyingCredentials: "Verifying credentials...",
      settingUpSession: "Setting up your session...",
      loadingWorkspace: "Loading your workspace...",
      welcomeBack: "Welcome back!",
      authenticationFailed: "Authentication failed",
      pleaseWait: "Please wait while we sign you in",
      almostDone: "Almost done..."
    },
    whatSortOfProduct: "What sort of Product?",
    go: "GO",
    turboApplication: "Turbo Application",
    fullApplication: "Full Application",
    addCertificateHolderModal: {
      addCertificateHolder: "Add Certificate Holder",
      fromHereCustomizeDetails:
        "From here, you can customize the details of your certificate.",
      certificateHolderInformation: "Certificate Holder Information",
      certificateHolderName: "Certificate Holder Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      townCity: "Town/City",
      province: "Province",
      postalCode: "Postal Code",
      country: "Country",
      numberOfDaysNoticeRequiredQuestion: "Number of days notice required?",
      numberOfDaysNoticeRequired: "Number of days notice required",
      lossPayeeOrAdditionalInsuredQuestion:
        "Is this person or entity also a loss payee or additional insured?",
      selectYourOption: "Select your option",
      lossPayee: "Loss Payee",
      additionalInsured: "Additional Insured",
      no: "No",
      natureOfInterest: "Nature of Interest",
      locationOfInterest: "Location of Interest",
      waiverOfSubrogationRequiredQuestion: "Is waiver of subrogation required?",
      yes: "Yes",
      crossLiabilityClauseRequiredQuestion:
        "Is a cross liability clause required? ?",
      save: "Save",
    },
    showArchrive: "Show Archived",
    certificateHolderInformation: "Certificate Holder Information",
    submit: "Submit",
    feedbackQuestion: "What kind of feedback would you like to give?",
    feedbackHeader: "Feedback",
    followUp: "Follow-up:",
    select: "Select ...",
    updateReminder: "Update Reminder",
    createNewReminder: "Create New Reminder",
    reminderTitle: "Reminder Title",
    titleOfReminder: "Title of reminder",
    reminderForMe: "Reminder For Me",
    status: "Status",
    selectAnOption: "Select an option",
    individualOrTeam: "Individual or Team",
    owner: "Owner",
    reminderFor: "Reminder For",
    selectAnOptionEllipsis: "Select an option...",
    selectOperations: "Select an operation by name, IBC or NAICS code.  Add multiple operations where needed.",
    category: "Category",
    selectADate: "Select a date",
    description: "Description",
    descriptionOfReminder: "Description of reminder",
    sendEmailNotificationToOwner: "Send email notification to owner",
    reminderDate: "Reminder Date",
    addNewReminderButton: "Add New Reminder",

    filters: "Filters",
    searchForClient: "Search for a Client",
    dueDate: "Due Date",
    from: "From",
    to: "To",
    all: "All",
    creator: "Creator",
    userGroup: "User Group",
    clearFilters: "Clear Filters",

    columnHeadingsReminders: {
      first: "Date created",
      second: "Creator",
      third: "Reminder",
      fourth: "Category",
      fifth: "Owner",
      sixth: "Client Name",
      seventh: "Due date",
      eighth: "Status",
      ninth: "Action",
    },

    reminderHeader: {
      heading1: "Reminders & Actions",
      heading2: "Filter or scroll through your reminders",
    },
    saveAndComplete: "Save and Complete",
    businessInterruptionCalculatorTitle:
      "BUSINESS INTERRUPTION - PROFITS CALCULATOR",
    businessInterruptionCalculatorDescription:
      "You can use this calculator to calculate the amount of insurance required for your clients Business Interruption on a 'Profits Form'. Please note, this information will be submitted to insurers for their consideration, but does not require or bind insurers to offer coverage which is similar or matching in limits.",
    tooltipImportExcel:
      "To import from Excel, make sure the file selected has columns exactly the same as this table. Importing a file will overwrite any existing data, if you would like to append, please export existing data to the file, make adjustments and re-import with all data",
    importCSV: "Import CSV",
    exportTemplate: "Download Template",
    exportCSV: "Download as CSV",
    runningTotal: "Running Total",
    selectColumn: "Select Column",
    amountToBeAdded: "Amount to be added",
    today: "Today",
    archived: "Archived",
    quoteyHeading: "Quotey Heading",
    columnHeadingInUploadedDocument: "Column Heading in Uploaded Document",
    wholeLinkCopied: "Whole link copied",
    wholeLinkCopiedToClipboard: "Whole link copied to clipboard",
    linkShareWithInsurers: "This shows the link which you can share with the Insurers",
    copyTheLink: "Copy the link",
    optionQuote: "Quote",
    optionRefer: "Refer",
    optionDecline: "Decline",
    decline: "Decline",
    optionPending: "Pending",
    refer: "Refer",
    pending: "Pending",
    limitIncluded: "Limit included",
    copy: "Copy",
    additionalInsurerModal: {
      heading: "Additional Insureds / Loss Payees",
      description:
        "This is a List of Additional Insured and Loss Payees associated with this client. please click 'Add' if you wish to add more",
      addButton: "Add",
      entityLabel: "Loss Payee / Additional Insured Entity",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "Town / City",
      province: "Province",
      postalCode: "Postal Code",
      country: "Country",
      checkboxesHeading:
        "Is this person or entity also a loss payee or additional insured?",
      additionalInsured: "Additional Insured",
      lossPayee: "Loss Payee",
      natureOfInterest: "Nature of Interest",
      locationOfInterest: "Location of Interest",
      noticePeriod: "Notice Period (days)",
      waiverOfSubrogation: "Waiver of subrogation ?",
      crossLiability: "Cross Liability?",
      saveButton: "Save",
      sampleCommonLabel: "Sample common label",
    },
    pdfSettingsModal: {
      title: "PDF Settings",
      displayTOC: "Display Table of Contents",
      displayAllQuestions: "Display All Questions",
      displayInFrench: "Display PDF in French",
    },
    reasonLimit: "Reason / Limit recommended",
    coverage: "Coverage",
    noRecommendation: "No recommendation at this stage",
    pleaseShareWithClient: "Please share the above link with the client",
    optionsToInclude: "Options to include",
    next: "NEXT",
    previous: "PREVIOUS",
    yourBrokerInfo: "Your brokerage information",
    handOffToClient: "Hand-off to Client",
    goToMarket: "Go to Market",
    backToHomePage: "Back To Homepage",
    goBackToCustomer: "Go back to Customer",
    prospectsHeader: "Your Prospects",
    prospectsSubHeader:
      "Filter below, or scroll through all your client activity",
    // Existing translations
    sendToInsurers: "Send To Insurers",
    insurersMatch:
      "These insurers are recommended as a potential match for your client.",
    digitalMarketingHub: "Digital Marketing Hub",
    for: "for",
    digitalHubDescription:
      "In the digital marketing hub you'll automatically see responses from participating insurers, and can also track responses from other markets.",
    insurer: "Insurer",
    product: "Product",
    recommendedscore: "Quotey Score",
    price: "Price",
    coveragelevel: "Coverage Level",
    rateit: "Give a Rating",
    stars: "stars",
    basedOn: "based on",
    reviewsText: "reviews",
    type: "Type",
    contact: "Contact",
    review: "Review",
    binderTitle: "Your Binders",
    binderSubInfo: "Filter below, or scroll through all your client activity",
    welcomeBack: "Welcome back,",

    // Additional translations for buttons and modals
    externalLink: {
      text: "Create and copy a link that you can send to insurers which provides them with a non-editable view of the client’s application in Quotey",
      buttonText: "Get external link to Quotey screens",
    },
    sendToSelectedInsurers: "Send to selected insurers",
    createEmailWithApplication: "Create email with application",
    downloadPDF: {
      text: "Download a PDF containing all the application questions and answers",
      buttonText: "Download application PDF",
    },
    editPDFOptions: "Edit PDF Options",
    downloadPDFButtonText: "Download PDF",
    imDoneAnswering: "I'm Done Answering",

    // **New Translations for Column Headings**
    columnHeadingsQuotes: {
      first: "Broker",
      second: "Client",
      third: "Vertical",
      fourth: "Contact Name",
      fifth: "Contact Number",
      sixth: "Contact Email",
      seventh: "Status",
      eighth: "Last Update",
      ninth: "Review Details",
    },

    // **New Translations for Paragraph**
    processParagraph: "Here is the process:",

    // **New Translations for Forms and Labels**
    form: {
      generalBindInformation: "General Bind Information",
      financials: "Financials",
      insurerLabel: "Insurer *",
      bindNumberLabel: "Bind Number",
      quoteReferenceLabel: "Quote Reference *",
      effectiveDateLabel: "Effective Date *",
      expiryDateLabel: "Expiry Date *",
      paymentMethodLabel: "Payment Method *",
      premiumLabel: "Premium *",
      insurerFeesLabel: "Insurer Fees *",
      brokerFeesLabel: "Broker Fees",
      premiumAndFeesLabel: "Premium & Fees *",
      taxRateApplicableLabel: "Tax rate applicable (%)",
      taxesPayableLabel: "Taxes payable",
      commissionRateLabel: "Commission rate (%)",
      commissionEarnedLabel: "Commission earned",
      selectPaymentMethodPlaceholder: "Select a payment method",
    },

    filters: {
      header: "Filters",
      dateHeader: "Date",
      statusHeader: "Status",
      verticalHeader: "Vertical",
      brokerHeader: "Broker",
      searchForClientPlaceholder: "Search for a Client",
      clearFiltersButton: "Clear Filters",
    },

    selectOptions: {
      week: "Week",
      month: "Month",
      year: "Year",
      custom: "Custom",
    },

    operationsBreakDown: {
      totalAnnualRevenues: "Total annual revenues",
      last12Months: "Last 12 months",
      projected12Months: "Projected 12 months",
      areRevenuesFromCanada: "Are all revenues generated from Canada?",
      percentageFromCanada: "% from Canada?",
      percentageFromUSA: "% from USA",
      percentageFromOtherCountries: "% from other countries",
      provideSplitByWork: "Provide a split by work",
      percentageResidential: "% residential",
      calculationResidential: "A + B / C",
      percentageCommercial: "% commercial",
      percentageIndustrial: "% industrial",
      percentageAgricultural: "% agricultural",
      followingIsEqual: "The following must equal 100%",
      error: "error",
    },
    helpOrTip: "Help or Tip",
    helpOrTipFromQuotey: "Help or Tip from Quotey",
    scratchpad: "Scratchpad for additonal notes",
    yes: "Yes",
    no: "No",
    dragAndDrop: "Drag 'n' drop some files here, or click to select files",
    locationNumber: "Location #",
    enterNumber: "Enter a Number",
    address: {
      autofill: "Autofill by a single search...",
      correspondenceLine1: "Correspondence address - line 1",
      correspondenceLine2: "Correspondence address - line 2",
      city: "City",
      province: "Province",
      country: "Country",
      postalCode: "Postal Code",
      noOptions: "No options",
    },
    otherInsurers: {
      heading1: "Other Insurers",
      heading2:
        "This is a list of additional insurers who may not have an appetite match for your client.",
      seeAllInsurers: "See All Insurers",
    },
    selectOne: "Select One",
    selectMultiple: "Select Multiple",
    addNewOperation: "Add a new Operation?",
    add: "Add", // New translation key
    operation: "Operation", // New translation key
    splitByWork: "Split By Work",
    revenuePercentage: "Revenue Percentage",
    whatTypeOfBusiness: "What type of business are you quoting today?",
    recentProspects: "Recent Prospects",
    showMore: "Show More",
    review: "Review",
    backToProspect: "Back to prospects",
    backToApplication: "Back to Application",
    fromOperations: " from operation",
    save: "Save",
    edit: "Edit",
    viewOffer: "View Offer",
    compareOffer: "Compare Offers",
    backToInsurerHub: "Back to Insurer Hub",
    filterForCovers: "Filter for Cover Names",
    cancel: "Cancel",
    update: "Update",
    search: "Search",
    brokerageAdmin: {
      uniqueCodesSavedSuccessfully: "Unique Codes Saved Successfully",
      enterBrokerCodeForBranch: "Enter Broker Code for Branch",
      insurerHeader:
        "You can customize the e-mail contacts and names that your team sees for insurers when sending to market.",
      topAdminHeader:
        "Jump into the driving seat and customize how Quotey works for your brokerage.",
      contactNumber: "Contact Number",
      website: "Website",
      additionalBranches: "Additional Branches",
      invoiceEmails: "Invoice Emails",
      primaryAddress: "Primary Address",
      brokerageName: "Brokerage Name",
      brokerageSummary:
        "Your brokerage name and contact details will appear on various pieces of documentation. Please ensure they are accurate and update as necessary.",
      contactDetailHeader:
        "You can add, suspend and update contact details for users in your brokerage",
      userName: "User Name",
      admin: "Admin",
      active: "Active",
      email: "Email",
      location: "Location",
      action: "Action",
      body: "Body",
      update: "Update",
      yes: "Yes",
      no: "No",
      contact: "Contact",
      contactEmail: "Contact e-mail",
      descriptionOrName: "Description or Name",
      default: "Default",
      addInsurerCode: "Add Insurer Code",
      bmsHeader: " Update BMS Credentials",
      bmsSelectText: "Select BMS Vendor:",
      bmsSelectWorkflow: "Select workflows to in-egrate",
      bmsCreateProspect: "Create new Prospect",
      bmsUpdateProspect: "Update Prospect",
      bmsUpdateBind: "Update on Bind",
      colorEnterHex: "Enter Color Hex Code",
      colorSelected: "Color Selected",
      colortSelect1: "Select Color #1",
      colortSelect2: "Select Color #2",
      colortSelect3: "Select Color #3",
      colorSaveTheme: "Save Theme",
      colorAddLogo: "Add Logo",
      colorImagePreview: "Image Preview",
      colorUpload: "Upload",
      colorCurrentLogo: "Current Logo",
      colorNoLogo: "No Logo Saved.",
      aboutUsHeader:
        "You can add, suspend and update about us in your brokerage",
      aboutUsTitleName: "Title name",
      aboutUsAddButton: "Add new about us",
      transactionListTitle: "Transaction List",
      subscriptionName: "Subscription Name",
      subscriptionPrice: "Subscription Price",
      tax: "Tax",
      date: "Date",
      totalAmount: "Total Amount",
      view: "View",
      noData: "-",
      loading: "Loading...",
      noTransactions: "No transactions found.",
      infoText:
        "You can add, suspend and update contact details for user-team in your brokerage",
      tableHeaderTitle: "Title",
      tableHeaderAction: "Action",
      buttonUpdate: "Update",
      buttonAddNewGroup: "Add a new group",
      noGroupData: "No groups available.",
      addGroupModalTitle: "Add a New Group",
      updateGroupModalTitle: "Update Group",
      errorLoading: "Error loading groups.",
      brokerageDetails: "Brokerage Details",
      userManagement: "User Management",
      insurerContacts: "Insurer Contacts",
      bmsCredentials: "BMS Credentials",
      logoAndColors: "Logo and Colors",
      aboutUs: "About Us",
      payment: "Payment",
      transaction: "Transaction",
      groupManagement: "Group Management",
      quoteyDashboard: "Quotey Dashboard",
      authManagement: "Auth Management",
      subscribeNow: "Subscribe Now",
      paymentConfirmation: "Payment Confirmation",
      paymentDescription:
        "Your credit card will be charged today for $100. This provides a license for you to add up to 10 users at your brokerage. Additional users can be added at the cost of $10 per additional user in each payment period (which will accrue into future payment periods). Your credit card will be automatically charged every 30 days for continued use of Quotey where the amount charged will be $100 for up to 10 users plus $10 per additional user. Your brokerages user count will be calculated based on the number",
      cardDetails: "Card details",
      addNewCardTitle: "Add New Card",
      cardsListTitle: "Cards List",
      errorProcessingPayment:
        "An error occurred while processing your payment.",
      addCard: "Add Card",
      addNewUser: "Add New User",
      addAnotherBranch: "Add Another Branch",
      addMore: "Add More",
      address1: "Address 1",
      address2: "Address 2",
      city: "City",
      province: "Province",
      postalCode: "Postal Code",
      save: "Save",
      fromHereCustomizeDetails:
        "From here, you can customize the details of your certificate.",
      certificateHolderInformation: "Certificate Holder Information",
      certificateHolderName: "Certificate Holder Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      townCity: "Town/City",
      numberOfDaysNoticeRequiredQuestion: "Number of days notice required?",
      numberOfDaysNoticeRequired: "Number of days notice required",
      lossPayeeOrAdditionalInsuredQuestion:
        "Is this person or entity also a loss payee or additional insured?",
      selectYourOption: "Select your option",
      lossPayee: "Loss Payee",
      additionalInsured: "Additional Insured",
      natureOfInterest: "Nature of Interest",
      locationOfInterest: "Location of Interest",
      waiverOfSubrogationRequiredQuestion: "Is waiver of subrogation required?",
      crossLiabilityClauseRequiredQuestion:
        "Is a cross liability clause required? ?",
      enterInsurerContactDetailFor: "Enter Insurer Contact Detail for",
      description: "Description",
      makeDefault: "Make Default",
      add: "Add",
      cancel: "Cancel",
      enterYourBrokerageCodesFor: "Enter Your Brokerage Codes for",
      brokerCode1: "Broker Code 1",
      brokerCode2: "Broker Code 2",
      brokerCode3: "Broker Code 3",
      enterBrokerCode1: "Enter Broker Code 1",
      enterBrokerCode2: "Enter Broker Code 2",
      enterBrokerCode3: "Enter Broker Code 3",
      masterCode: "Master Code",
      enterDefaultCode: "Enter Default Code",
      users: "Users",
      quoteyUserId: "Quotey UserId",
      insurerUserId: "Insurer User-Id",
      insurerPassword: "Insurer Password",
      uniqueCodesSavedSuccessfully: "Unique Codes Saved Successfully",
      addedContactSuccessfully: "Added Contact Successfully",
      defaultUpdatedSuccessfully: "Default Updated Successfully",
      contactDeletedSuccessfully: "Contact Deleted Successfully",
      enterEmail: "Enter Email",
      enterDescription: "Enter Description",
      insurerPasswordPlaceholder: "Enter Insurer Password",
      startApplicationFullAppMode: "Start Application in Full App Mode",
      themeSavedSuccessfully: "New Theme Saved",
      logoSavedSuccessfully: "New Logo Saved",
    },
    newProspectPopover: {
      whichProductQuestion: "Which product do you want to create an application for?",
    },
    // **New Translation Keys for Dropdown**
    // actionsDropdown: {
    //   title: "Actions",
    //   bindQuote: "Bind Quote",
    //   firmUpAndBindQuote: "Firm Up And Bind Quote",
    //   referToInsurer: "Refer To Insurer",
    //   editQuote: "Edit Quote",
    //   viewQuote: "View Quote",
    //   info: "Info",
    //   downloadInsurerDocument: "Download Insurer Document",
    // },
    addBuilding: " Add another property at this location",
    defaultSelectedOptionText: "No recommendation at this stage",
    dashboard: {
      // **Dashboard Translations**
      yourDashboard: "Your Dashboard",
      filters: "Filters",
      date: "Date",
      status: "Status",
      vertical: "Vertical",
      broker: "Broker",
      select: "Select ...",
      clearFilters: "Clear Filters",
      summary: "SUMMARY",
      businessSegments: "BUSINESS SEGMENTS",
      currentProspectStatus: "CURRENT PROSPECT STATUS",
      salesAnalysisByVertical: "SALES ANALYSIS BY VERTICAL",
      salesAnalysisByBroker: "SALES ANALYSIS BY BROKER",
      prospectsAddedBySegment: "PROSPECTS ADDED BY SEGMENT",
      addedProspects: "ADDED PROSPECTS",
      keyPipelineRatios: "KEY PIPELINE RATIOS",
      salesFunnel: "SALES FUNNEL",

      // **Paragraphs**
      helpingNavigate: "Helping you navigate the business insurance world…",
      thanksSpeaking:
        "Thanks so much for taking the time to speak with me about your insurance needs. We know you're super busy running your business so it really means a lot to us.",
      asDiscussed:
        "As discussed, we've scanned the insurance market to compare prices and important coverages to find the best deal for you, and you'll be happy to know that your business immediately qualified for a great quote with one of our insurer partners.",
      weNotDoneYet: "We're not done yet…",
      beforeRecommendations:
        "Before we make any recommendations, we want to connect with a few other insurers that we think will be interested in your business and competitive. They might not be able to beat the quotes we've already provided in this document, but we think it's worth a shot.",
      itTakesDays:
        "It usually takes at least a few days for insurers to review and come back with quotes. In some cases, they may come back with more questions first. Either way, we'll be tracking their responses and come back to you as soon as we hear anything.",
      followingPagesInfo:
        "In the following pages, we've included some really important information…",
      whatHappensNext: "What happens next…",
      hopefullyInfo:
        "Hopefully this process has helped you get a better feeling for what your insurance will cost. We're still trying to connect with other insurers to increase your options, and we'll come back to you as soon as we have any news.",
      signAndReturn:
        "In the meantime, can we ask you to sign and return this document confirming all the information is accurate?",
      ofCourse:
        "Of course, if you do want to go ahead with the option we've already got, then we can get this set-up for you straight away! Just give us a call, and we'll get everything set-up for you.",

      // **Dropdown Items**
      thisWeek: "This Week",
      thisMonth: "This Month",
      thisYear: "This Year",
      custom: "Custom",
      no_selection: "No Selection", // Optional

      // **No Data Found Message**
      noDataFound: "No Data Found In This Time Period",

      // **Additional Keys for Dropdown Statuses**
      status_sold: "Sold",
      status_quoted: "Quoted",
      status_nurture: "Nurture",
      status_bad_lead: "Bad Lead",

      brokers: "Brokers",
      transactions: "Transactions",
      prospects: "Prospects",
      sales: "Sales",

      // **Additional Keys for Select Placeholders**
      select_status: "Select Status",
      select_vertical: "Select Vertical",
      select_broker: "Select Broker",
      prospects_created: "Prospects Created",
      insurer_count: "Insurer Count",
      business_segments_over_selected_time_period:
        "BUSINESS SEGMENTS OVER SELECTED TIME PERIOD",
    },
    userManagementModal: {
      transferProspects: "Transfer prospects to a different user",
      contactDetailHeader:
        "You can add, suspend and update contact details for users in your brokerage",
      userName: "User Name",
      admin: "Admin",
      active: "Active",
      email: "Email",
      contactNumber: "Contact Number",
      location: "Location",
      action: "Action",
      update: "Update",
      yes: "Yes",
      no: "No",
      addNewUser: "Add New User",
      enterName: "Enter Name",
      enterTemporaryPassword: "Enter Temporary Password",
      enterEmail: "Enter Email",
      enterContact: "Enter Contact",
      enterLocation: "Enter Location",
      roleJobTitle: "Role / Job Title",
      enterJobTitleRole: "Enter Job Title/Role",
      biographyMax250Chars: "Biography (max 250 chars)",
      enterBiographyMax250Chars: "Enter Biography (max 250 chars)",
      languagePreference: "Language Preference",
      ableToGoToMarket: "Able to go to market",
      ableToBind: "Able to bind",
      prospectsPermissions: "Prospects Permissions",
      ableToViewAllProspects: "Able to view all prospects",
      updateUser: "Update User",
      name: "Name",
      contact: "Contact",
      permissions: "Permissions",
    },
    userImageUpload: {
      imageUpload: "Image Upload",
      dropzoneText: "Drag 'n' drop some files here, or click to select files",
      cropImage: "Crop Image",
      fitToSize: "Fit to Size",
      imagePreview: "Image Preview",
      currentImage: "Current Image",
      noImage: "No Image",
      noLogo: "No Logo",
      userDetailsUpdated: "User Details Updated",
    },
    documentUpload: {
      dragAndDrop: "Drag 'n' drop some files here, or click to select files",
      fileInformation: "File Information",
      pleaseChooseFileType: "Please choose type of document",
      comments: "Comments",
      upload: "Upload",
      fileTypeNotSelected: "File Type is not selected",
      date: "Date",
      fileType: "Category",
      fileName: "File Name",
      size: "Size",
      download: "Download",
      comment: "Comment",
      somethingWentWrong: "Something went wrong while getting Pdf",
      documentTypeList: {
        application: "Application",
        policyDocument: "Policy Document",
        quotation: "Quotation",
        riskPhoto: "Risk Photo",
        inspectionReport: "Inspection report",
        clientEmail: "Client email",
        insurerEmail: "Insurer email",
        otherEmail: "Other email",
        buildingValuation: "Building valuation",
        statementOfValues: "Statement of Values",
        schedule: "Schedule",
        profitsCalculation: "Profits Calculation",
        other: "Other",
      },
    },

    transactionData: {
      documentNames: {
        'Send to Market': 'Send to Market',
        'Bind Request': 'Bind Request',
        'Client Presentation': 'Client Presentation',
        'Binder Letter': 'Binder Letter',
        'Certificate': 'Certificate',
        'Invoice': 'Invoice',
        'Employee handbook': 'Employee handbook',
        'Continued Quote': 'Continued Quote',
      },
      autoComments: {
        'Status change': 'Status change',
        'Owner was changed': 'Owner was changed',
        'Invoice PDF': 'Invoice PDF',
        'PDF downloaded': 'PDF downloaded',
        'Schedule Upload': 'Schedule Upload',
        'Empty': 'Empty',
        'New': 'New',
        'Quote received': 'Quote received',
      },
    },

    userManagement: {
      insuranceCredentialsChangedSuccessfully:
        "Insurance Credentials Changed Successfully",
      passwordChangedSuccessfully: "Password Changed Successfully",
      personalInformation: "Personal Information",
      email: "Email",
      enterEmail: "Enter Email",
      name: "Name",
      enterName: "Enter Name",
      phoneNumber: "Phone Number",
      enterPhoneNumber: "Enter Phone Number",
      roleJobTitle: "Role / Job title",
      enterRoleJobTitle: "Enter Role/Job title",
      biography: "Biography",
      enterBiography: "Enter Biography (max 250 chars)",
      location: "Location",
      pleaseChoose: "please choose",
      update: "Update",
      updatePassword: "Update Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      passwordsDoNotMatch: "Passwords do not match",
      updateBrokerManagementCreds: "Update Broker Management Creds",
      addBmsDetails:
        "Add details of your BMS credentials so that Quotey can automatically update your BMS.",
      bmsUsername: "BMS UserName",
      bmsField1: "BMS Field 1",
      enterField1: "Enter Field 1",
      bmsField2: "BMS Field 2",
      enterField2: "Enter Field 2",
      updateInsuranceCredentials: "Update Insurance Credentials",
      insurer: "Insurer",
      username: "Username",
      password: "Password",
      togglePasswordVisibility: "toggle password visibility",
    },
    whatsNew: "What’s New?",
    close: "Close",
    personalInformation: "Personal Information",
    security: "Security",
    bmsCredentials: "BMS Credentials",
    insurerCredentials: "Insurer Credentials",
    coveragePopOverHeader: "Package More Coverages",
    coveragePopOverDescription:"Select one or more of the following coverage options to pacakge them into this application. Note, this will insert questions into the application in sections that you have already completed",
    paymentProvider: {
      description: "You can add, payment details",
      providerName: "Payment Provider Name",
      action: "Action",
      addProvider: "Add Payment Provider",
      updateProvider: "Update Payment Provider",
      premium: "Premium",
      insurerFees: "Insurer Fees",
      insurerFee: "Insurer Fee",
      brokerFees: "Broker Fees",
      brokerFee: "Broker Fee",
      taxRate: "Tax Rate",
      taxAmount: "Tax Amount",
      totalAmount: "Total Amount",
      totalAmountFinanced: "Total Amount To Be Financed",
      key: "Key",
      value: "Value",
      type: "Type",
      enterKey: "Enter key",
      enterValue: "Enter value",
      selectOption: "Select an option",
      listValue: "List Value",
      commaInstructions: "Enter comma-separated values (e.g., value1, value2, value3)",
      enterListValue: "Enter List Value",
      delete: "Delete",
      addKeyName: "Add Key Name",
      fieldRequired: "This field is required",
      list: "List",
      number: "Number",
      text: "Text",
      date: "Date",
    },

    // SSO Management Translations
    sso: {
      pageTitle: "Single Sign-On Management",
      enableSSO: "Enable Single Sign-On (SSO)",
      completeSAMLConfig: "Complete SAML Configuration",
      ssoActive: "Single Sign-On is Active",
      shareValues: "Share these values with your IT administrator",
      enterIdpDetails: "Enter your IdP configuration details",
      configureSSO: "Choose how to configure your identity provider settings. You can either use a metadata URL for automatic configuration or enter details manually.",
      useMetadataURL: "Use Metadata URL",
      manualConfiguration: "Manual Configuration",
      metadataURLSetup: "Metadata URL Setup",
      metadataURLDescription: "Get the metadata URL from your identity provider (Okta, Azure AD, Google Workspace, etc.). This URL typically ends with \"/metadata\" and contains all the required SAML configuration.",
      idpMetadataURL: "Identity Provider Metadata URL",
      metadataURLPlaceholder: "https://your-idp.com/app/abc123/sso/saml/metadata",
      metadataURLHelp: "The XML metadata URL provided by your identity provider. This will automatically configure all SAML settings.",
      configureWithMetadataURL: "Configure with Metadata URL",
      processingMetadata: "Processing Metadata...",
      metadataProcessedSuccessfully: "Metadata URL Processed Successfully!",
      extractedConfiguration: "Extracted Configuration:",
      ssoURL: "SSO URL",
      entityID: "Entity ID",
      certificateImported: "Certificate: Imported successfully",
      refreshStatus: "Refresh Status",
      important: "Important",
      nameidFormat: "Name ID Format",
      nameidFormatHelp: "How user identities are formatted",
      identityProviderConfiguration: "Identity Provider Configuration",
      connectionInformation: "Connection Information",
      status: "Status",
      active: "ACTIVE",
      connectionID: "Connection ID",
      connectionIDHelp: "Reference ID for support purposes",
      created: "Created",
      lastUpdated: "Last Updated",
      editConfiguration: "Edit Configuration",
      deleteConnection: "Delete Connection",
      editSAMLConfiguration: "Edit SAML Configuration",
      cancel: "Cancel",
      saveChanges: "Save Changes",
      saving: "Saving...",
      editError: "Edit Error:",
      nextSteps: "Next steps: Share your application login URL with team members and let them know they can use their company credentials to sign in.",
      howItWorks: "How it works: We'll create a secure SAML connection and provide you with the configuration details your IT administrator needs to set up SSO in your identity provider.",
      settingUpSAMLConnection: "Setting up your SAML connection...",
      setupInProgress: "This may take a moment. Please don't close this page.",
      setupError: "Setup Error:",
      startSSOSetup: "Start SSO Setup",
      settingUp: "Setting up...",
      configurationError: "Configuration Error:",
      activatingSSO: "Activating SSO...",
      itAdminDescription: "Your IT admin will need these exact values to configure SAML in your identity provider (Okta, Azure AD, Google Workspace, etc.).",
      emailAttributeWarning: "Make sure your IT admin maps the email attribute correctly in your IdP. Users' email addresses must match exactly.",
      idpSSOURL: "IdP Single Sign-On URL",
      fromMetadataURL: "From Metadata URL",
      extractedFromMetadata: "Extracted from metadata URL - configuration complete",
      ssoURLPlaceholder: "https://your-idp.com/sso/saml",
      ssoURLHelp: "The URL where users will be redirected to sign in (from your IdP)",
      idpEntityID: "IdP Entity ID",
      entityIDPlaceholder: "https://your-idp.com/entity-id",
      entityIDHelp: "Unique identifier for your identity provider",
      idpSingleLogoutURL: "IdP Single Logout URL (Optional)",
      sloURLPlaceholder: "https://your-idp.com/slo/saml",
      sloURLHelp: "Optional: URL for single logout functionality",
      x509Certificate: "X.509 Certificate",
      certificateImportedFromMetadata: "Certificate Imported Successfully from Metadata URL",
      certificatePlaceholder: "-----BEGIN CERTIFICATE-----\nMIIDXTCCAkWgAwIBAgIJAKoK/heBjcOuMA0GCSqGSIb3DQEBBQUAMEUxCzAJBgNV\n...\n-----END CERTIFICATE-----",
      certificateHelp: "The full X.509 certificate from your IdP (including BEGIN/END lines)",
      certificateExtractedFromMetadata: "Certificate extracted and imported from metadata URL - configuration complete",
      configureAttributeMapping: "Configure Attribute Mapping",
      requiredToActivate: "Required to Activate Connection",
      metadataProcessingComplete: "Metadata processing complete! Now configure how SAML attributes map to user fields to activate your connection.",
      attributeMappingDescription: "Map SAML attributes from your IdP to user fields. These tell us which SAML attributes contain user information.",
      progressStatus: "Progress Status:",
      ssoURLExtracted: "SSO URL extracted from metadata",
      entityIDExtracted: "Entity ID extracted from metadata",
      certificateImportedFromMetadataStatus: "Certificate imported from metadata",
      attributeMappingNeeded: "Attribute mapping needed to activate",
      commonAttributeNames: "Common Attribute Names",
      emailAttributeOptions: "Email: email, EmailAddress, mail",
      firstNameAttributeOptions: "First Name: firstName, givenName, first_name",
      lastNameAttributeOptions: "Last Name: lastName, surname, last_name, sn",
      emailAttributeName: "Email Attribute Name",
      emailAttributePlaceholder: "email",
      emailAttributeHelp: "The SAML attribute name that contains the user's email address",
      firstNameAttributeName: "First Name Attribute Name",
      firstNameAttributePlaceholder: "firstName",
      firstNameAttributeHelp: "The SAML attribute name that contains the user's first name",
      lastNameAttributeName: "Last Name Attribute Name",
      lastNameAttributePlaceholder: "lastName",
      lastNameAttributeHelp: "The SAML attribute name that contains the user's last name",
      configurationError: "Configuration Error:",
      activatingSSO: "Activating SSO...",
      completeSSOActivation: "Complete SSO Activation",
      activateSingleSignOn: "Activate Single Sign-On",
      loadingSSOConfiguration: "Loading SSO configuration...",
      errorLoadingSSO: "Error loading SSO status:",
      tryAgain: "Try Again",
      ssoActiveDescription: "Your team members can now sign in seamlessly using your company's identity provider. New users will be automatically provisioned when they first sign in.",
      ssoConfigurationDetails: "SSO Configuration Details",
      serviceProviderDetails: "Service Provider Details",
      singleSignOnURL: "Single Sign-On URL (ACS URL)",
      acsURLHelp: "Where your IdP sends SAML responses",
      audienceURI: "Audience URI (SP Entity ID)",
      audienceURIHelp: "Unique identifier for your application",
      nameIDFormat: "Name ID Format",
      nameIDFormatHelp: "How user identities are formatted",
      identityProviderConfiguration: "Identity Provider Configuration",
      idpSSOURLActive: "IdP SSO URL",
      idpSSOURLHelp: "Your identity provider's sign-on endpoint",
      idpEntityIDActive: "IdP Entity ID",
      idpEntityIDActiveHelp: "Your identity provider's unique identifier",
      certificateMasked: "Certificate (Masked)",
      certificateVerificationHelp: "X.509 certificate for signature verification",
      attributeMappings: "Attribute Mappings",
      defaultMappings: "Default mappings",
      connectionInformation: "Connection Information",
      status: "Status",
      active: "ACTIVE",
      connectionID: "Connection ID",
      connectionIDHelp: "Reference ID for support purposes",
      created: "Created",
      lastUpdated: "Last Updated",
      editConfiguration: "Edit Configuration",
      deleteConnection: "Delete Connection",
      editSAMLConfiguration: "Edit SAML Configuration",
      cancel: "Cancel",
      saving: "Saving...",
      saveChanges: "Save Changes",
      nextSteps: "Next steps: Share your application login URL with team members and let them know they can use their company credentials to sign in.",
      howItWorks: "How it works: We'll create a secure SAML connection and provide you with the configuration details your IT administrator needs to set up SSO in your identity provider.",
      settingUpSAMLConnection: "Setting up your SAML connection...",
      settingUpMessage: "This may take a moment. Please don't close this page.",
      setupError: "Setup Error:",
      startSSOSetup: "Start SSO Setup",
      settingUp: "Setting up...",
      deleteSAMLConnection: "Delete SAML Connection",
      deleteSAMLMessage: "Are you sure you want to delete this SAML connection? This action will immediately disable single sign-on for your organization and cannot be undone.",
      confirmationText: "delete",
      samlConnection: "SAML connection",

      // Missing Form Labels
      identityProviderMetadataURL: "Identity Provider Metadata URL",
      idpSingleSignOnURL: "IdP Single Sign-On URL",
      idpEntityID: "IdP Entity ID",
      idpSingleLogoutURL: "IdP Single Logout URL (Optional)",
      x509Certificate: "X.509 Certificate",
      emailAttributeName: "Email Attribute Name",
      firstNameAttributeName: "First Name Attribute Name",
      lastNameAttributeName: "Last Name Attribute Name",

      // Status Messages
      metadataURLProcessedSuccessfully: "Metadata URL Processed Successfully!",
      extractedConfiguration: "Extracted Configuration:",
      ssoURL: "SSO URL:",
      entityID: "Entity ID:",
      certificateImportedSuccessfully: "Certificate: Imported successfully",
      configurationError: "Configuration Error:",
      editError: "Edit Error:",
      setupError: "Setup Error:",

      // Success Messages
      fromMetadataURL: "From Metadata URL",
      certificateImportedFromMetadata: "Certificate Imported Successfully from Metadata URL",
      extractedFromMetadataComplete: "Extracted from metadata URL - configuration complete ✅",
      metadataProcessingComplete: "Metadata processing complete! Now configure how SAML attributes map to user fields to activate your connection.",
      attributeMappingNeeded: "Attribute mapping needed to activate",

      // Button Text
      configureWithMetadataURL: "Configure with Metadata URL",
      processingMetadata: "Processing Metadata...",
      completeSSOActivation: "Complete SSO Activation",
      editConfiguration: "Edit Configuration",
      editSAMLConfiguration: "Edit SAML Configuration",

      // Placeholders
      metadataURLPlaceholder: "https://your-idp.com/app/abc123/sso/saml/metadata",
      ssoURLPlaceholder: "https://your-idp.com/sso/saml",
      entityIDPlaceholder: "https://your-idp.com/entity-id",
      sloURLPlaceholder: "https://your-idp.com/slo/saml",
      sloURLPlaceholderOptional: "https://your-idp.com/slo/saml (optional)",
      emailAttributePlaceholder: "email",
      firstNameAttributePlaceholder: "firstName",
      lastNameAttributePlaceholder: "lastName",

      // Help Text
      idpSsoURLHelp: "The URL where users will be redirected to sign in (from your IdP)",
      idpEntityIDHelp: "Unique identifier for your identity provider",
      x509CertificateHelp: "The full X.509 certificate from your IdP (including BEGIN/END lines)",
      certificateExtractedFromMetadata: "Certificate extracted and imported from metadata URL - configuration complete ✅",
      attributeMappingDescription: "Map SAML attributes from your IdP to user fields. These tell us which SAML attributes contain user information.",

      // Section Headers
      serviceProviderDetails: "Service Provider Details",
      identityProviderConfiguration: "Identity Provider Configuration",
      singleSignOnURLACS: "Single Sign-On URL (ACS URL)",
      audienceURISPEntityID: "Audience URI (SP Entity ID)",

      // Common Attribute Names
      commonAttributeNames: "Common Attribute Names",
      commonAttributeNamesTitle: "Common Attribute Names:",
      emailAttributeOptions: "Email: email, EmailAddress, mail",
      firstNameAttributeOptions: "First Name: firstName, givenName, first_name",
      lastNameAttributeOptions: "Last Name: lastName, surname, last_name, sn",

      // Additional Labels
      nameIDFormat: "Name ID Format",
      uniqueIdentifierForApplication: "Unique identifier for your application",
      howUserIdentitiesFormatted: "How user identities are formatted",

      // Missing translations for comprehensive localization
      copied: "Copied!",
      copy: "Copy",
      status: "Status",
      active: "ACTIVE",
      attributeMappings: "Attribute Mappings",
      certificateMasked: "Certificate (Masked)",
      enableSingleSignOn: "Enable Single Sign-On (SSO)",
      allowYourTeam: "Allow your team to sign in seamlessly using your corporate identity provider like Okta, Azure AD, Google Workspace, or any SAML-compatible system.",
      whereYourIdP: "Where your IdP sends SAML responses",
      yourIdentityProviderSignOn: "Your identity provider's sign-on endpoint",
      yourIdentityProviderUnique: "Your identity provider's unique identifier",
      x509CertificateSignature: "X.509 certificate for signature verification",
      sloURLPlaceholderOptional: "https://your-idp.com/slo/saml (optional)",
      activatingSSO: "Activating SSO...",
      settingUpSAMLConnectionDots: "Setting up your SAML connection...",
      thisMayTakeAMoment: "This may take a moment. Please don't close this page.",
      certificateImportedFromMetadataURL: "Certificate Imported Successfully from Metadata URL",
      ssoURLExtractedFromMetadata: "SSO URL extracted from metadata",
      entityIDExtractedFromMetadata: "Entity ID extracted from metadata",
      certificateImportedFromMetadataStatus: "Certificate imported from metadata",
      attributeMappingNeededToActivate: "Attribute mapping needed to activate"
    },

    // Stytch Organization Management Translations
    stytchOrg: {
      pageTitle: "Stytch Organization Settings",
      organizationConfiguration: "Organization Configuration",
      configurationDescription: "Configure your Stytch organization settings to control authentication methods, email domains, and user provisioning policies for your application.",
      loadingText: "Loading Stytch organization settings...",

      // Basic Information Section
      basicInformation: "Basic Information",
      organizationName: "Organization Name",
      organizationNamePlaceholder: "Your Company Name",
      organizationNameHelp: "The display name for your organization",
      organizationSlug: "Organization Slug",
      organizationSlugPlaceholder: "your-company",
      organizationSlugHelp: "URL-friendly identifier (lowercase, no spaces)",
      organizationLogoURL: "Organization Logo URL",
      organizationLogoURLPlaceholder: "https://your-company.com/logo.png",
      organizationLogoURLHelp: "Optional: URL to your organization's logo",

      // Email Configuration Section
      emailConfiguration: "Email Configuration",
      allowedEmailDomains: "Allowed Email Domains",
      noDomains: "No domains added yet",
      addDomain: "Add Domain",
      removeDomain: "Remove",
      emailDomainsHelp: "Users can only sign up with email addresses from these domains",
      emailInvites: "Email Invites",
      emailInvitesHelp: "Control who can send email invitations",
      emailJITProvisioning: "Email JIT Provisioning",
      emailJITProvisioningHelp: "Automatically create accounts for email users (Note: ALL_ALLOWED is not supported)",

      // Authentication & Security Section
      authenticationAndSecurity: "Authentication & Security",
      authenticationMethods: "Authentication Methods",
      authenticationMethodsHelp: "Which authentication methods are permitted",
      mfaPolicy: "MFA Policy",
      mfaPolicyHelp: "Multi-factor authentication requirement",
      mfaMethods: "MFA Methods",
      mfaMethodsHelp: "Which MFA methods are available",

      // SSO Configuration Section
      ssoConfiguration: "SSO Configuration",
      ssoJITProvisioning: "SSO JIT Provisioning",
      ssoJITProvisioningHelp: "Automatically create accounts for SSO users",

      // Dropdown Options
      allAllowed: "All Allowed",
      restricted: "Restricted",
      notAllowed: "Not Allowed",
      optional: "Optional",
      requiredForAll: "Required for All",

      // Buttons and Actions
      saveOrganizationSettings: "Save Organization Settings",
      updatingSettings: "Updating Settings...",

      // Messages
      errorLabel: "Error:",
      successLabel: "Success!",
      successMessage: "Organization settings have been updated.",

      // Members Management Section
      organizationMembers: "Organization Members",
      membersDescription: "Manage organization members and send invitations to new users.",
      inviteNewMember: "Invite New Member",
      sendInvitation: "Send Invitation",
      sendingInvitation: "Sending...",
      invitationHelp: "Enter an email address to send an organization invitation",
      currentMembers: "Current Members",
      refresh: "Refresh",
      loadingMembers: "Loading members...",
      noMembers: "No members found. Invite your first member above!",
      joined: "Joined:",
      invitationPending: "Invitation Pending",
      inviteSuccessMessage: "Member invitation has been sent.",

      // Placeholders
      domainPlaceholder: "example.com",
      memberEmailPlaceholder: "member@example.com"
    },

    // Grid/Dropdown Toggle
    selectFromDropdown: "Select from Dropdown",
    selectFromGrid: "Select from Grid",
  },
  fr: {
    welcome: "Bienvenue chez Quotey !",
    signupInstruction:
      "Pour compléter le processus d'inscription, vous devez accepter les Conditions d'utilisation de Quotey et définir un mot de passe confidentiel",
    termsHeading: "Conditions générales d'utilisation",
    agreeButton: "J'accepte ces Conditions générales d'utilisation",
    certificateDownloading: "Téléchargement du certificat en cours.....",
    certificateCreated: "Certificat créé",
    modalTitle: "Marquer comme terminé ?",
    modalDescription: "Voulez-vous marquer ce rappel ou cette tâche comme terminé(e) ?",
    followUpText: "Voulez-vous que Quotey vous rappelle de faire un suivi avec le client ?",
    followUpTitle: "Relancer le client pour compléter la demande",
    autoReminderText: "Voulez-vous que Quotey vous envoie un rappel pour vérifier la réponse de l'assureur ?",
    autoReminderTitle: "Vérifiez la confirmation de l'indication par le souscripteur.",
    certificateDownloadOptions: "Options de téléchargement du certificat",
    importanceIconTooltipGeneral: "Cette question est généralement essentielle sur le marché.",
    importanceIconTooltipFor: "Cette question est essentielle pour : {insurerNames}",
     // Fallback text when no second-level text is provided
     locationFallback: "Emplacement",
     // Label for Delete icons
     deleteLabel: "Supprimer",
     // Button text for adding a property (building)
     addPropertyButton: "Ajouter propriété",
     // Modal texts for removing a property (building)
     removePropertyModalTitle: "Supprimer la propriété",
     removePropertyModalBody:
       "Êtes-vous sûr de vouloir supprimer cette propriété ?",
     // Button text for modal actions
     cancelButton: "Annuler",
     deleteButton: "Supprimer",
     // Default building title prefix when no custom title is set
     defaultBuildingTitlePrefix: "Propriété #",  
    uploadDocumentsTitle: "Téléverser des documents supplémentaires avec l'e-mail",
    createEmailButtonText: "Créer un e-mail avec la proposition d'assurance",
    quoteComparisonToastMessage: "Vous pouvez sélectionner et comparer jusqu'à {maxQuotes} devis dans la présentation client. Ceci afin de garantir à votre client une présentation nette et claire sans surcharger la page. Veuillez sélectionner les trois devis les plus pertinents et réessayer.",
       // Modal Titles
       emailDownloadedTitle: "Téléchargement de l'e-mail",
       emailSentToInsurerTitle: "E-mail envoyé à l'assureur",
       // Modal Body Messages (Email Modal)
       emailSentForIndication:"Un courriel a été envoyé à l'assureur pour lui demander de confirmer les indications fournies. Une fois les conditions contractuelles reçues, vous pourrez valider ce devis dans Quotey.",
       emailSentForConfirmation: "Un e-mail a été envoyé à l'assureur pour qu'il confirme l'engagement. La police n'est pas engagée tant que l'assureur ne l'a pas confirmé.",
       emailSentWithDetails: "Un e-mail a été envoyé à l'assureur, avec une copie à vous-même, contenant les détails de l'engagement. La police est désormais engagée.",
       manualQuoteEmailInstruction: "Comme ce devis a été généré en dehors de Quotey, vous devrez envoyer cet e-mail à l'assureur pour engager la police. Un e-mail d'engagement a été généré dans vos téléchargements pour faciliter cette opération. Il vous suffit de cliquer pour ouvrir cet e-mail, de l'ajuster si nécessaire et de l'envoyer.",
       approvedCasualtyLegalMessage: "Un e-mail a été envoyé dans votre boîte de réception, l'engagement et la facture ont été joints.",
       // Common Buttons and Reminder
       closeButton: "Fermer",
       reminderText: "Voulez-vous que Quotey envoie un rappel pour vérifier la réception de la police",
       reminderTitle: "Vérifiez les documents de la police",
       reminderCategory: "Attente des documents de la police",
       // Bind Failed Modal
       bindFailedTitle: "Échec de l'engagement",
       bindFailedIssue: "Nous avons rencontré un problème lors de la tentative d'engagement de votre police.",
       bindFailedRetry: "Veuillez réessayer l'engagement. Si le problème persiste, contactez le support pour obtenir de l'aide.",
       bindFailedNotCompleted: "Quotey a été informé de cet échec d'engagement. L'engagement n'a pas été complété.",
    
    fileDownloadNotification: "Un fichier a été téléchargé sur le côté gauche de l'écran",
  bindRequestNotification: "Une demande d'engagement a été créée et téléchargée sur votre écran. Veuillez l'envoyer à l'assureur pour demander l'engagement. Veuillez noter que les polices ne sont pas engagées tant qu'elles n'ont pas été confirmées par l'assureur",
    toastTranslation:"Un e-mail est en cours de téléchargement automatique. Vous le verrez en bas à gauche de votre écran sous forme de fichier téléchargé et vous pourrez cliquer dessus pour l'ouvrir, le consulter, ajouter des commentaires si nécessaire et l'envoyer. Si votre ordinateur vous demande l'autorisation de télécharger ce fichier, veuillez lui accorder l'accès et 'garder' le fichier.",
    required: "Requis",
    notRequired: "Non Requis",
    notIncluded: "Non Inclus",
    included: "Inclus",
    reminderText:
      "Voulez-vous que Quotey programme un rappel pour vérifier les réponses des assureurs ?",
    reminderTitle: "Vérifier les réponses des assureurs.",
    reminderCategory: "Vérifier les devis",
    pdfDownloadedToast:
      "Un PDF est en cours de téléchargement automatique. Vous le verrez en bas à gauche de votre écran sous forme de fichier téléchargé.",
    buttonToast:
      "Nous faisons de notre mieux pour que ce bouton fasse ce qu'il est censé faire -- en attendant, profitez de la première option : générer un email basé sur du texte",
    alertSelectOne:
      "Veuillez sélectionner un assureur avant de faire la demande de souscription.",
    alertSelectOnlyOne:
      "Veuillez sélectionner un seul assureur pour la demande de souscription.",
    actionsDropdown: {
      fees: "Frais",
      addBrokerFee: "Ajouter des frais de courtier",
      // Dropdown button title and options
      title: "Actions",
      editQuote: "Modifier la soumission",
      bindQuote: "Lier le devis",
      firmUpAndBindQuote: "Devis raffermi",
      referToInsurer: "Référer à l'assureur",
      viewQuote: "Voir le devis",
      info: "Informations",
      downloadInsurerDocument: "Télécharger le document de l'assureur",
      // Popover (Bind Modal) static texts
      bindConfirmationHeader: "Confirmation de liaison",
      bindConfirmationText:
        "Comme les conditions ont été fournies à titre indicatif, veuillez confirmer les conditions liables avec le souscripteur :",
      finalPremiumQuoted: "Prime finale indiquée :",
      insurerFees: "Frais de l'assureur :",
      totalPremiumFees: "Prime totale et frais :",
      underwriterName: "Nom du souscripteur",
      underwriterEmail: "Email du souscripteur",
      dateConfirmedByUnderwriter: "Date de confirmation par le souscripteur",
      // Bind modal additional texts
      editCoveragesQuestion:
        "Avez-vous besoin de modifier les couvertures initialement indiquées ?",
      radioYes: "Oui",
      radioNo: "Non",
      editCoveragesExplanation:
        "Lorsque vous cliquez sur le bouton de validation, vous serez d'abord dirigé vers la modification des couvertures. Une fois terminé, vous pourrez revenir au Digital Marketing Hub et lier.",
      proceedButton: "Procéder",
      // Alert messages (toast)
      alertSelectOne:
        "veuillez sélectionner un seul assureur avant de faire la demande de liaison.",
      alertSelectOnlyOne:
        "veuillez sélectionner un seul assureur pour la demande de liaison.",
      // Email body texts
      emailSubject: "Votre demande d'assurance",
      emailBody: `<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invitation à la demande</title>
  <style>
    body {
      font-family: Arial, sans-serif;
    }
    .email-container {
      width: 100%;
      max-width: 600px;
    }
    .centered-table {
      width: 100%;
      text-align: center;
    }
    .button {
      display: inline-block;
      background-color: #007bff;
      color: #ffffff;
      text-decoration: none;
      padding: 12px 20px;
      font-size: 16px;
      border-radius: 5px;
      font-weight: bold;
    }
  </style>
</head>
<body>
  <table class="email-container" cellpadding="0" cellspacing="0">
    <tr>
      <td>
        <p>Bonjour,</p>
        <p>
          Comme convenu, voici un lien où vous pouvez compléter toutes les informations nécessaires
          afin que nous puissions contacter nos assureurs pour vous proposer des options.
        </p>
        <p>
          <a href="{link}" class="button">Cliquez ici pour compléter votre demande en ligne</a>
        </p>
        <p>
          Je serai automatiquement notifié(e) une fois que vous aurez terminé et pourrai poursuivre le processus.
        </p>
        <p>
          Si vous avez des questions, n'hésitez pas à me le faire savoir. <br />
          J'ai hâte de lancer ce processus pour vous.
        </p>
        <p>
          Merci, <br />
          {brokerName}
        </p>
      </td>
    </tr>
  </table>
</body>`,
    },
    inlineFeesForm: {
      brokerFeeLabel: "Frais du courtier :",
      premiumLabel: "Prime :",
      insurerFeeLabel: "Frais de l'assureur :",
      totalPremiumFeesLabel: "Prime totale et frais :",
      doneButton: "Terminé",
      brokerFeePlaceholder: "$0",
    },
    chsModal: {
      full: "Complète",
      turbo: "Turbo",
      handoffHeader: "Transfert au client",
      instructionText:
        "Cela créera un lien unique pour que votre client puisse compléter la demande à son rythme. Vous serez notifié par email et sur Quotey lorsqu'il aura terminé.",
      sectionsIncludeQuestion:
        "Quelles sections de la demande souhaitez-vous inclure ?",
      includeAll: "Tout inclure",
      includeSpecific:
        "Inclure uniquement les sections spécifiques sélectionnées :",
      shortenedApplicationQuestion:
        "Souhaitez-vous que le client voie la version raccourcie de la demande Turbo ?",
      emailOrLinkQuestion:
        "Voulez-vous que Quotey crée un email incluant le lien que vous pouvez envoyer, ou fournir un lien que vous pouvez copier et coller dans votre propre email ?",
      email: "Email",
      link: "Lien",
      finish: "Terminer",
      // Auto reminder text:
      reminderText:
        "Voulez-vous que Quotey définisse un rappel pour vous afin de vérifier avec le client ?",
      reminderTitle: "Relancer le client pour compléter la demande",
      reminderCategory: "Relance de transfert",
      // Email content:
      emailSubject: "Votre demande d'assurance",
      emailBody: `<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Invitation à la demande</title>
  <style>
    body {
      font-family: Arial, sans-serif;
    }
    .email-container {
      width: 100%;
      max-width: 600px;
    }
    .centered-table {
      width: 100%;
      text-align: center;
    }
    .button {
      display: inline-block;
      background-color: #007bff;
      color: #ffffff;
      text-decoration: none;
      padding: 12px 20px;
      font-size: 16px;
      border-radius: 5px;
      font-weight: bold;
    }
  </style>
</head>
<body>
  <table class="email-container" cellpadding="0" cellspacing="0">
    <tr>
      <td>
        <p>Bonjour,</p>
        <p>
          Comme convenu, voici un lien où vous pouvez compléter toutes les informations nécessaires
          afin que nous puissions contacter nos assureurs pour vous proposer des options.
        </p>
        <p>
          <a href="{link}" class="button">Cliquez ici pour compléter votre demande en ligne</a>
        </p>
        <p>
          Je serai automatiquement notifié(e) une fois que vous aurez terminé et pourrai poursuivre le processus.
        </p>
        <p>
          Si vous avez des questions, n'hésitez pas à me le faire savoir. <br />
          J'ai hâte de lancer ce processus pour vous.
        </p>
        <p>
          Merci, <br />
          {brokerName}
        </p>
      </td>
    </tr>
  </table>
</body>`,
    },
    ChsSignoffModal: {
      chsButtontxt: "Confirmer et signer",
      chsHeading: "Signature et consentement de la proposition d'assurance",
      chsElectronicApplicationNotice:
        "Dès réception de votre consentement, une demande d'assurance signée électroniquement sera créée pour nos archives et une copie vous sera envoyée",
      chsConsentElectronicDisclosures:
        "Je consens aux divulgations électroniques et à la signature",
      chsViewFullDisclosure: "Voir la déclaration complète de divulgation",
      chsESignatureAgreementText:
        "Vous reconnaissez signer cet accord électroniquement. En signant ce document électroniquement, vous consentez aux termes et conditions juridiquement contraignants de cet accord. Vous acceptez en outre que votre signature sur ce document (ci-après dénommée « signature électronique ») soit aussi valable que si vous aviez signé le document à la main. Vous acceptez également qu'aucune autorité de certification ou vérification tierce ne soit nécessaire pour valider votre signature électronique, et que l'absence d'une telle certification ou vérification ne nuira en rien à la force exécutoire de votre signature électronique ou à tout accord résultant entre vous et Quotey. Vous confirmez être autorisé à conclure cet accord",
      chsConsentCreditScore:
        "Je consens à l'utilisation du score de crédit par les assureurs dans le processus d'obtention d'une assurance",
      chsCreditInfoConsentDetails:
        "Si vous permettez à un assureur d'obtenir vos informations de crédit, vous acceptez que cet assureur collecte, utilise et divulgue : (a) les informations personnelles contenues dans votre rapport de crédit (qui peuvent contenir des informations sur votre solvabilité, votre capacité de crédit et votre score d'assurance basé sur le crédit) dans le but d'évaluer, de proposer, de souscrire et de gérer tout produit d'assurance qui vous est offert, d'enquêter et de régler les réclamations d'assurance, de détecter et de prévenir la fraude à l'assurance et d'améliorer nos services ; et (b) votre nom et adresse, date de naissance et numéro de téléphone à une agence de notation de crédit afin d'obtenir des informations de crédit vous concernant. Vous acceptez qu'un assureur puisse divulguer vos informations de crédit à des tiers raisonnablement liés aux informations et offres d'assurance pertinentes qui vous sont fournies, y compris les agences de notation de crédit, les organismes de réglementation et les filiales d'un assureur. Ces divulgations peuvent avoir lieu dans le but d'obtenir des rapports de crédit actuels ou futurs pertinents pour maintenir, mettre à jour ou renouveler vos polices d'assurance. Vous pouvez révoquer votre consentement à tout moment en informant votre courtier en assurance. Je suis autorisé à signer au nom de tous les assurés nommés sur ma police",
      chsConfirmAccuracy:
        "Je confirme que les informations de cette demande sont exactes",
      chsInsurerRelianceText:
        "Les assureurs se baseront sur chacune des réponses fournies dans cette demande pour décider de vous offrir ou non des produits d'assurance ainsi que les primes, conditions et termes de chaque produit. Ils considèrent chaque réponse comme essentielle à leurs décisions. Ils se réservent le droit d'invalider ou de révoquer vos polices si vous fournissez des informations inexactes ou incomplètes. Vous acceptez d'informer rapidement votre courtier en assurance si les informations fournies dans cette demande deviennent inexactes ou obsolètes. Remplir et signer cette demande n'engage pas votre organisation à acheter un produit d'assurance, ni l'assureur à en émettre un.",
      chsAuthorizedIndividual: "Nom de la personne autorisée",
      chsRoleWithinBusiness: "Rôle au sein de l'entreprise (le cas échéant)",
    },
    GtmModal: {
      gtmGoToMarket: "Aller sur le marché",
      gtmUnansweredQuestionsList: "Liste des questions non répondues",
      gtmUnansweredQuestionsDescription:
        'Les questions importantes suivantes n\'ont pas été répondues. Cela pourrait impacter votre capacité à recevoir des devis instantanés et précis des assureurs. Si vous cliquez sur la question concernée, vous serez redirigé directement pour y répondre. Si les informations fournies vous conviennent, vous pouvez passer en cliquant sur "Aller sur le marché"',
      gtmDoNotShowAgain: "Ne plus afficher ce message pour ce prospect",
    },
    ChsModalO: {
      confirmAndSign: "Confirmer et signer",
      applicationSignatureAndConsent:
        "Signature et consentement de la proposition d'assurance",
      electronicApplicationNotice:
        "Dès réception de votre consentement, une demande d'assurance signée électroniquement sera créée pour nos archives et une copie vous sera envoyée",
      consentToElectronicDisclosuresAndSignature:
        "Je consens aux divulgations électroniques et à la signature",
      viewFullDisclosureStatement:
        "Voir la déclaration complète de divulgation",
      eSignatureAgreementText:
        "Vous reconnaissez signer cet accord électroniquement. En signant ce document électroniquement, vous consentez aux termes et conditions juridiquement contraignants de cet accord. Vous acceptez en outre que votre signature sur ce document (ci-après dénommée « signature électronique ») soit aussi valable que si vous aviez signé le document à la main. Vous acceptez également qu'aucune autorité de certification ou vérification tierce ne soit nécessaire pour valider votre signature électronique, et que l'absence d'une telle certification ou vérification ne nuira en rien à la force exécutoire de votre signature électronique ou à tout accord résultant entre vous et Quotey. Vous confirmez être autorisé à conclure cet accord",
      consentToUseCreditScore:
        "Je consens à l'utilisation du score de crédit par les assureurs dans le processus d'obtention d'une assurance",
      creditInfoConsentDetails:
        "Si vous permettez à un assureur d'obtenir vos informations de crédit, vous acceptez que cet assureur collecte, utilise et divulgue : (a) les informations personnelles contenues dans votre rapport de crédit (qui peuvent contenir des informations sur votre solvabilité, votre capacité de crédit et votre score d'assurance basé sur le crédit) dans le but d'évaluer, de proposer, de souscrire et de gérer tout produit d'assurance qui vous est offert, d'enquêter et de régler les réclamations d'assurance, de détecter et de prévenir la fraude à l'assurance et d'améliorer nos services ; et (b) votre nom et adresse, date de naissance et numéro de téléphone à une agence de notation de crédit afin d'obtenir des informations de crédit vous concernant. Vous acceptez qu'un assureur puisse divulguer vos informations de crédit à des tiers raisonnablement liés aux informations et offres d'assurance pertinentes qui vous sont fournies, y compris les agences de notation de crédit, les organismes de réglementation et les filiales d'un assureur. Ces divulgations peuvent avoir lieu dans le but d'obtenir des rapports de crédit actuels ou futurs pertinents pour maintenir, mettre à jour ou renouveler vos polices d'assurance. Vous pouvez révoquer votre consentement à tout moment en informant votre courtier en assurance. Je suis autorisé à signer au nom de tous les assurés nommés sur ma police",
      confirmAccuracyOfInformation:
        "Je confirme que les informations de cette demande sont exactes",
      nameOfAuthorizedIndividual: "Nom de la personne autorisée",
      roleWithinBusiness: "Rôle au sein de l'entreprise (le cas échéant)",
    },
    reminderModal: {
      setReminderOrTask: "Définir un rappel ou une tâche",
      quoteyReminderQuestion:
        "Voulez-vous que Quotey définisse un rappel ou une tâche pour ce client ?",
      yes: "Oui",
      no: "Non",
      reminderTitle: "Titre du rappel",
      titlePlaceholder: "Titre",
      category: "Catégorie",
      client: "Client",
      clientsLabel: "Clients",
      targetDate: "Date cible",
      ownerType: "Type de propriétaire",
      me: "Moi",
      otherPeople: "Autres personnes",
      team: "Équipe",
      owner: "Propriétaire",
      description: "Description",
      status: "Statut",
      statusOpen: "Ouvert",
      statusCompleted: "Complété",
      statusOnHold: "En attente",
      statusOther: "Autre",
      sendEmailNotificationToOwner:
        "Envoyer une notification par e-mail au propriétaire ?",
      updateReminder: "Mettre à jour le rappel",
      createReminder: "Créer un rappel",
    },
    addLocation: "Ajouter",
    personalInformation: "Informations personnelles",
    security: "Sécurité",
    bmsCredentials: "Identifiants BMS",
    insurerCredentials: "Identifiants d'assureur",
    update: "Mettre à jour",
    userManagement: {
      insuranceCredentialsChangedSuccessfully:
        "Les identifiants d'assurance ont été mis à jour avec succès",
      passwordChangedSuccessfully: "Mot de passe modifié avec succès",
      personalInformation: "Informations personnelles",
      email: "Courriel",
      enterEmail: "Entrez courriel",
      name: "Nom",
      enterName: "Entrez le nom",
      phoneNumber: "Numéro de téléphone",
      enterPhoneNumber: "Entrez le numéro de téléphone",
      roleJobTitle: "Rôle / Titre du poste",
      enterRoleJobTitle: "Entrez le rôle / titre du poste",
      biography: "Biographie",
      enterBiography: "Entrez la biographie (max 250 caractères)",
      location: "Localisation",
      pleaseChoose: "veuillez choisir",
      update: "Mettre à jour",
      updatePassword: "Mettre à jour le mot de passe",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
      updateBrokerManagementCreds:
        "Mettre à jour les identifiants de gestion du courtier",
      addBmsDetails:
        "Ajoutez les détails de vos identifiants BMS afin que Quotey puisse mettre à jour automatiquement votre BMS.",
      bmsUsername: "Nom d'utilisateur BMS",
      bmsField1: "Champ BMS 1",
      enterField1: "Entrez le champ 1",
      bmsField2: "Champ BMS 2",
      enterField2: "Entrez le champ 2",
      updateInsuranceCredentials: "Mettre à jour les identifiants d'assurance",
      insurer: "Assureur",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      togglePasswordVisibility: "basculer la visibilité du mot de passe",
    },

    clientHandOffAgreeText: {
      viewFullDisclosureStatement:
        "Voir la déclaration de divulgation complète",
      electronicSignatureAcknowledgement:
        "Vous reconnaissez signer cet accord électroniquement. En signant ce document électroniquement, vous consentez aux termes et conditions légalement contraignants de cet accord. Vous acceptez en outre que votre signature sur ce document (ci-après dénommée votre \"Signature électronique\") est aussi valide que si vous aviez signé le document à la main. Vous acceptez également qu'aucune autorité de certification ou autre vérification par un tiers n'est nécessaire pour valider votre Signature électronique, et que l'absence d'une telle certification ou vérification par un tiers n'affectera en aucun cas l'applicabilité de votre Signature électronique ou de tout accord résultant entre vous et Quotey. Vous confirmez que vous êtes autorisé à conclure cet accord.",
      creditScoreConsent:
        "Je consens à l'utilisation de la cote de crédit par les assureurs dans le processus d'obtention d'une assurance",
      creditInformationDisclosure:
        "Si vous permettez à un assureur d'obtenir vos informations de crédit, vous acceptez que cet assureur collecte, utilise et divulgue : (a) les informations personnelles contenues dans votre rapport de crédit (qui peuvent contenir des informations sur votre situation de crédit, votre solvabilité, votre capacité de crédit et votre cote d'assurance basée sur le crédit) aux fins d'évaluation, d'offre, de souscription et de gestion de tout produit d'assurance qui vous est offert, d'enquête et de règlement des réclamations d'assurance, de détection et de prévention de la fraude à l'assurance et d'amélioration de nos services ; et (b) votre nom et adresse, votre date de naissance et votre numéro de téléphone à une agence d'évaluation du crédit dans le but d'obtenir des informations de crédit à votre sujet. Vous acceptez qu'un assureur puisse divulguer vos informations de crédit à des tiers raisonnablement liés aux informations et offres d'assurance pertinentes qui vous sont fournies, y compris les agences d'évaluation du crédit, les organismes de réglementation et les sociétés affiliées d'un assureur. Ces divulgations peuvent avoir lieu aux fins d'obtenir des rapports de crédit actuels ou futurs pertinents pour le maintien, la mise à jour ou le renouvellement de vos polices d'assurance. Vous pouvez révoquer votre consentement à tout moment en informant votre courtier d'assurance. Je suis autorisé à signer au nom de tous les assurés nommés sur ma police.",
      informationAccuracyConfirmation:
        "Je confirme que l'exactitude des informations contenues dans cette demande est correcte",
      applicationInformationReliance:
        "Les assureurs se fieront à chacune des réponses données dans cette demande pour décider de vous offrir ou non des produits d'assurance ainsi que les primes, les conditions générales de chaque produit. Les assureurs considèrent que chaque réponse est essentielle à leurs décisions. Les assureurs se réservent le droit d'invalider ou de répudier vos polices si vous fournissez des informations inexactes ou incomplètes. Vous acceptez d'informer rapidement votre courtier d'assurance si les informations fournies dans cette demande deviennent inexactes ou obsolètes. Le fait de remplir et de signer cette demande ne vous oblige pas à acheter un produit d'assurance, et n'oblige pas non plus l'assureur à émettre un produit d'assurance. Je déclare que je suis autorisé à représenter mon organisation dans cette transaction et que les déclarations contenues dans cette demande sont vraies, complètes et exactes. Je reconnais et j'accepte que le fait de ne pas fournir des informations vraies, complètes et exactes dans cette demande peut entraîner l'annulation de toute assurance émise en se fondant sur cette demande et/ou le refus de toute réclamation en vertu de toute police émise.",
      nameOfAuthorizedIndividual: "Nom de la personne autorisée",
      roleWithinTheBusiness: "Rôle au sein de l'entreprise (si pertinent)",
      onReceiptOfYourConsent:
        "Dès réception de votre consentement, une demande d'assurance signée électroniquement sera créée pour nos dossiers et une copie vous sera partagée.",
      iConsentToElectronicDisclosuresAndSignature:
        "Je consens aux divulgations et à la signature électroniques",
      iConsentToUseOfCreditScore:
        "Je consens à l'utilisation de la cote de crédit",
      iConfirmTheAccuracyOfInformation:
        "Je confirme l'exactitude des informations",
      applicationSignatureAndConsent: "Signature et consentement de la demande",
      confirmAndSign: "Confirmer et signer",
    },
    viewChanges: "Voir les modifications",
    close: "Fermer",
    clientAnswerLog: "Journal des réponses du client",
    clientLogTable: {
      question: "Question",
      oldAnswer: "Ancienne réponse",
      newAnswer: "Nouvelle réponse",
    },
    outOf5: "sur 5",
    essentialQuestion:
      "Cette question est essentielle. Elle a un score d'importance de",
    pressEnterToSearch: "Appuyez sur Entrée pour rechercher",
    pressEnterToExecute: "Appuyez sur Entrée pour rechercher",
    email: "Courriel",
    name: "Nom",
    incorrectUsernamePassword: "Nom d'utilisateur ou mot de passe incorrect !",
    emailAddressPlaceholder: "Adresse courriel",
    passwordPlaceholder: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    forgotPasswordLink: "Mot de passe oublié ?",
    loginButton: "Se connecter",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    signUpLink: "S'inscrire",

    // Authentication loading messages
    authentication: {
      authenticating: "Authentification...",
      verifyingCredentials: "Vérification des identifiants...",
      settingUpSession: "Configuration de votre session...",
      loadingWorkspace: "Chargement de votre espace de travail...",
      welcomeBack: "Bon retour !",
      authenticationFailed: "Échec de l'authentification",
      pleaseWait: "Veuillez patienter pendant que nous vous connectons",
      almostDone: "Presque terminé..."
    },
    selectOperations: "Sélectionnez une opération par nom, code IBC ou code SCIAN. Ajoutez plusieurs opérations si nécessaire.",
    documentUpload: {
      dragAndDrop:
        "Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers",
      fileInformation: "Informations sur le fichier",
      pleaseChooseFileType: "Veuillez choisir le type de document",
      comments: "Commentaires",
      upload: "Télécharger",
      fileTypeNotSelected: "Le type de fichier n'est pas sélectionné",
      date: "Date",
      fileType: "Catégorie",
      fileName: "Nom du fichier",
      size: "Taille",
      download: "Télécharger",
      comment: "Commentaire",
      somethingWentWrong:
        "Un problème est survenu lors de la récupération du PDF",
      documentTypeList: {
        application: "Demande",
        policyDocument: "Document de police",
        quotation: "Soumission",
        riskPhoto: "Photo du risque",
        inspectionReport: "Rapport d'inspection",
        clientEmail: "Courriel du client",
        insurerEmail: "Courriel de l'assureur",
        otherEmail: "Autre courriel",
        buildingValuation: "Évaluation du bâtiment",
        statementOfValues: "Statut des valeurs",
        schedule: "Annexe",
        profitsCalculation: "Calcul des bénéfices",
        other: "Autre",
      },
    },

    transactionData: {
      documentNames: {
        'Send to Market': 'Envoi au marché',
        'Bind Request': 'Demande de souscription',
        'Client Presentation': 'Présentation client',
        'Binder Letter': 'Lettre de souscription',
        'Certificate': 'Certificat',
        'Invoice': 'Facture',
        'Employee handbook': "Manuel de l'employé",
        'Continued Quote': 'Soumission continuée',
      },
      autoComments: {
        'Status change': 'Changement de statut',
        'Owner was changed': 'Le propriétaire a été changé',
        'Invoice PDF': 'PDF de facture',
        'PDF downloaded': 'PDF téléchargé',
        'Schedule Upload': 'Téléversement de cédule',
        'Empty': 'Vide',
        'New': 'Nouveau',
        'Quote received': 'Soumission reçue',
      },
    },

    otherInsurers: {
      heading1: "Autres assureurs",
      heading2:
        "Voici une liste d'assureurs supplémentaires qui pourraient ne pas correspondre aux besoins de votre client.",
      seeAllInsurers: "Voir tous les assureurs",
    },
    close: "Fermé",
    whatsNew: "Quoi de neuf?",
    whatSortOfProduct: "Quel genre de produit ?",
    go: "ALLER",
    cancel: "Annuler",
    turboApplication: "Proposition rapide",
    fullApplication: "Proposition complète",
    userImageUpload: {
      imageUpload: "Téléchargement d'image",
      dropzoneText:
        "Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers",
      cropImage: "Recadrer l'image",
      fitToSize: "Ajuster à la taille",
      imagePreview: "Aperçu de l'image",
      currentImage: "Image actuelle",
      noImage: "Pas d'image",
      noLogo: "Pas de logo",
      userDetailsUpdated: "Détails de l'utilisateur mis à jour",
    },
    userManagementModal: {
      transferProspects: "Transférer les prospects à un autre utilisateur",
      contactDetailHeader:
        "Vous pouvez ajouter, suspendre et mettre à jour les coordonnées des utilisateurs de votre cabinet",
      userName: "Nom d'utilisateur",
      admin: "Admin",
      active: "Actif",
      email: "Courriel",
      contactNumber: "Numéro de contact",
      location: "Adresse",
      action: "Action",
      update: "Mettre à jour",
      yes: "Oui",
      no: "Non",
      addNewUser: "Ajouter un nouvel utilisateur",
      enterName: "Entrer le nom",
      enterTemporaryPassword: "Entrer le mot de passe temporaire",
      enterEmail: "Entrez votre adresse courriel",
      enterContact: "Entrer le contact",
      enterLocation: "Entrer l'emplacement",
      roleJobTitle: "Rôle / Titre du poste",
      enterJobTitleRole: "Entrer le titre/rôle du poste",
      biographyMax250Chars: "Biographie (max 250 caractères)",
      enterBiographyMax250Chars: "Entrer la biographie (max 250 caractères)",
      languagePreference: "Préférence de langue",
      ableToGoToMarket: "Capable d'aller au marché",
      ableToBind: "Capable de lier",
      prospectsPermissions: "Autorisations des prospects",
      ableToViewAllProspects: "Capable de voir tous les prospects",
      updateUser: "Mettre à jour l'utilisateur",
      name: "Nom",
      contact: "Téléphone",
      permissions: "Autorisations",
    },
    addCertificateHolderModal: {
      addCertificateHolder: "Ajouter un titulaire de certificat",
      fromHereCustomizeDetails:
        "À partir d'ici, vous pouvez personnaliser les détails de votre certificat.",
      certificateHolderInformation:
        "Informations sur le titulaire du certificat",
      certificateHolderName: "Nom du titulaire du certificat",
      addressLine1: "Adresse Ligne 1",
      addressLine2: "Adresse Ligne 2",
      townCity: "Ville",
      province: "Province",
      postalCode: "Code Postal",
      country: "Pays",
      numberOfDaysNoticeRequiredQuestion: "Nombre de jours de préavis requis ?",
      numberOfDaysNoticeRequired: "Nombre de jours de préavis requis",
      lossPayeeOrAdditionalInsuredQuestion:
        "Cette personne ou entité est-elle également bénéficiaire en cas de sinistre ou assuré supplémentaire ?",
      selectYourOption: "Sélectionnez votre option",
      lossPayee: "Bénéficiaire en cas de sinistre",
      additionalInsured: "Assuré supplémentaire",
      no: "Non",
      natureOfInterest: "Nature de l'intérêt",
      locationOfInterest: "Lieu d'intérêt",
      waiverOfSubrogationRequiredQuestion:
        "Une renonciation à la subrogation est-elle requise ?",
      yes: "Oui",
      crossLiabilityClauseRequiredQuestion:
        "Une clause de responsabilité croisée est-elle requise ?",
      save: "Enregistrer",
    },
    showArchrive: "Afficher archivé",
    certificateHolderInformation: "Informations sur le titulaire du certificat",
    submit: "Soumettre",
    feedbackQuestion: "Quel type de commentaire souhaitez-vous donner ?",
    feedbackHeader: "Commentaires",
    followUp: "Suivi :",
    select: "Sélectionner",
    addNewReminderButton: "Ajouter un nouveau rappel",
    updateReminder: "Mettre à jour le rappel",
    createNewReminder: "Créer un nouveau rappel",
    reminderTitle: "Titre du rappel",
    titleOfReminder: "Titre du rappel",
    reminderForMe: "Rappel pour moi",
    status: "Statut",
    selectAnOption: "Sélectionner une option",
    individualOrTeam: "Individuel ou Équipe",
    owner: "Propriétaire",
    reminderFor: "Rappel pour",
    selectAnOptionEllipsis: "Sélectionner une option...",
    category: "Étape",
    selectADate: "Sélectionner une date",
    description: "Description",
    descriptionOfReminder: "Description du rappel",
    sendEmailNotificationToOwner:
      "Envoyer une notification par e-mail au propriétaire",
    reminderDate: "Date du rappel",

    filters: "Filtres",
    searchForClient: "Rechercher un client",
    dueDate: "Date de suivi",
    from: "De",
    to: "À",
    all: "Tous",
    creator: "Saisi par",
    userGroup: "Groupe d'utilisateurs",
    clearFilters: "Effacer les filtres",
    columnHeadingsReminders: {
      first: "Date d'ouverture",
      second: "Saisi par",
      third: "Nom du rappel",
      fourth: "Étape",
      fifth: "Propriétaire",
      sixth: "Nom du client",
      seventh: "Date du suivi",
      eighth: "Statut",
      ninth: "Action",
    },
    reminderHeader: {
      heading1: "Rappels & Suivis",
      heading2:
        "Utiliser le filtre ou sélectionner une page ci-dessous pour voir tous vos rappels.",
    },
    saveAndComplete: "Enregistrer et terminer",
    businessInterruptionCalculatorTitle:
      "CALCULATRICE D'INTERRUPTION D'ACTIVITÉ - BÉNÉFICES",
    businessInterruptionCalculatorDescription:
      "Vous pouvez utiliser cette calculatrice pour calculer le montant d'assurance requis pour l'interruption d'activité de vos clients sur un 'Formulaire de Bénéfices'. Veuillez noter que ces informations seront soumises aux assureurs pour leur examen, mais n'exigent ni ne lient les assureurs à offrir une couverture similaire ou équivalente en termes de limites.",
    tooltipImportExcel:
      "Pour importer depuis Excel, assurez-vous que le fichier sélectionné contient exactement les mêmes colonnes que ce tableau.",
    importCSV: "Importer CSV",
    exportTemplate: "Télécharger le tableau",
    exportCSV: "Télécharger en CSV",
    runningTotal: "Total en cours",
    selectColumn: "Sélectionner une colonne",
    amountToBeAdded: "Montant à ajouter",
    today: "Aujourd'hui",
    archived: "Archivé",
    quoteyHeading: "En-tête Quotey",
    columnHeadingInUploadedDocument: "En-tête de colonne dans le document téléversé",
    wholeLinkCopied: "Lien entier copié",
    wholeLinkCopiedToClipboard: "Lien entier copié dans le presse-papiers",
    linkShareWithInsurers: "Ceci affiche le lien que vous pouvez partager avec les assureurs",
    copyTheLink: "Copier le lien",
    optionQuote: "Devis",
    optionRefer: "Référer",
    refer: "Référer",
    optionDecline: "Refuser",
    decline: "Refuser",
    optionPending: "En attente",
    pending: "En attente",
    limitIncluded: "Limite incluse",
    copy: "Copie",
    additionalInsurerModal: {
      heading: "Assurés supplémentaires / Bénéficiaires de pertes",
      description:
        "Ceci est la liste des assurés supplémentaires et des bénéficiaires de pertes associés à ce client. Veuillez cliquer sur 'Ajouter' si vous souhaitez en ajouter davantage.",
      addButton: "Ajouter",
      entityLabel: "Bénéficiaire de perte / Assuré supplémentaire",
      addressLine1: "Adresse (ligne 1)",
      addressLine2: "Adresse (ligne 2)",
      city: "Ville",
      province: "Province",
      postalCode: "Code postal",
      country: "Pays",
      checkboxesHeading:
        "Cette personne ou entité est-elle également un bénéficiaire de perte ou un assuré supplémentaire ?",
      additionalInsured: "Assuré supplémentaire",
      lossPayee: "Bénéficiaire de perte",
      natureOfInterest: "Nature de l'intérêt",
      locationOfInterest: "Emplacement de l'intérêt",
      noticePeriod: "Délai de préavis (jours)",
      waiverOfSubrogation: "Renonciation à la subrogation ?",
      crossLiability: "Responsabilité croisée ?",
      saveButton: "Enregistrer",
      sampleCommonLabel: "Étiquette commune d'exemple",
    },
    pdfSettingsModal: {
      title: "Paramètres PDF",
      displayTOC: "Afficher la table des matières",
      displayAllQuestions: "Afficher toutes les questions",
      displayInFrench: "Afficher le PDF en français",
    },
    reasonLimit: "Raison / Limite recommandée",
    dashboard: {
      // **Dashboard Translations**
      yourDashboard: "Votre Tableau de Bord",
      filters: "Filtres",
      date: "Date",
      select: "Sélectionner",
      status: "Statut",
      vertical: "Secteur",
      broker: "Courtier",
      clearFilters: "Effacer les Filtres",
      summary: "RÉSUMÉ",
      businessSegments: "SEGMENTS D'ACTIVITÉ",
      currentProspectStatus: "Statut ACTUEL DU PROSPECT",
      salesAnalysisByVertical: "ANALYSE DES VENTES PAR SECTEUR",
      salesAnalysisByBroker: "ANALYSE DES VENTES PAR COURTIER",
      prospectsAddedBySegment: "PROSPECTS AJOUTÉS PAR SEGMENT",
      addedProspects: "PROSPECTS AJOUTÉS",
      keyPipelineRatios: "RAPPORTS CLÉS DE LA PIPLINE",
      salesFunnel: "ENTONNOIR DE VENTES",

      brokers: "Courtiers",
      transactions: "Transactions",
      prospects: "Prospects",
      sales: "Ventes",

      // **Paragraphs**
      helpingNavigate:
        "Vous aider à naviguer dans le monde de l'assurance commerciale…",
      thanksSpeaking:
        "Merci beaucoup d'avoir pris le temps de discuter avec moi de vos besoins en assurance. Nous savons que vous êtes très occupé à gérer votre entreprise, donc cela signifie vraiment beaucoup pour nous.",
      asDiscussed:
        "Comme discuté, nous avons analysé le marché de l'assurance pour comparer les prix et les couvertures importantes afin de trouver la meilleure offre pour vous, et vous serez heureux de savoir que votre entreprise a immédiatement été qualifiée pour un excellent devis avec l'un de nos partenaires assureurs.",
      weNotDoneYet: "Nous n'avons pas encore terminé…",
      beforeRecommendations:
        "Avant de faire des recommandations, nous souhaitons nous connecter avec quelques autres assureurs que nous pensons intéressés par votre entreprise et compétitifs. Ils pourraient ne pas être en mesure de battre les devis que nous avons déjà fournis dans ce document, mais nous pensons que cela vaut la peine d'essayer.",
      itTakesDays:
        "Il faut généralement au moins quelques jours aux assureurs pour examiner et revenir avec des devis. Dans certains cas, ils peuvent revenir avec plus de questions d'abord. Quoi qu'il en soit, nous suivrons leurs réponses et reviendrons vers vous dès que nous entendrons quelque chose.",
      followingPagesInfo:
        "Dans les pages suivantes, nous avons inclus des informations vraiment importantes…",
      whatHappensNext: "Que se passe-t-il ensuite…",
      hopefullyInfo:
        "Nous espérons que ce processus vous a aidé à mieux comprendre combien votre assurance coûtera. Nous essayons toujours de nous connecter avec d'autres assureurs pour augmenter vos options, et nous reviendrons vers vous dès que nous aurons des nouvelles.",
      signAndReturn:
        "En attendant, pouvons-nous vous demander de signer et de retourner ce document confirmant que toutes les informations sont exactes ?",
      ofCourse:
        "Bien sûr, si vous souhaitez aller de l'avant avec l'option que nous avons déjà, nous pouvons mettre cela en place pour vous immédiatement ! Appelez-nous simplement, et nous mettrons tout en place pour vous.",

      // **Dropdown Items**
      thisWeek: "Cette Semaine",
      thisMonth: "Ce Mois",
      thisYear: "Cette Année",
      custom: "Personnalisé",
      no_selection: "Aucune Sélection", // Optional

      // **No Data Found Message**
      noDataFound: "Aucune donnée trouvée pour cette période",

      // **Additional Keys for Dropdown Statuses**
      status_sold: "Vendu",
      status_quoted: "Devisé",
      status_nurture: "Nourrir",
      status_bad_lead: "Mauvais Prospect",

      // **Additional Keys for Select Placeholders**
      select_status: "Sélectionnez le Statut",
      select_vertical: "Sélectionnez le Secteur",
      select_broker: "Sélectionnez le Courtier",
      prospects_created: "Prospects Créés",
      insurer_count: "Nombre d'Assureurs",
      business_segments_over_selected_time_period:
        "SEGMENTS D'ACTIVITÉ AU COURS DE LA PÉRIODE SÉLECTIONNÉE",
    },
    coverage: "Protection",
    defaultSelectedOptionText: "Aucune recommandation à ce stade",
    noRecommendation: "Aucune recommandation à ce stade",
    // actionsDropdown: {
    //   title: "Actions",
    //   bindQuote: "Lier le Devis",
    //   firmUpAndBindQuote: "Confirmer et Lier le Devis",
    //   referToInsurer: "Référer à l'Assureur",
    //   editQuote: "Modifier le Devis",
    //   viewQuote: "Voir le Devis",
    //   info: "Infos",
    //   downloadInsurerDocument: "Télécharger le Document de l'Assureur",
    // },

    addBuilding: "Ajouter un bâtiment ou une propriété",
    brokerageAdmin: {
      uniqueCodesSavedSuccessfully: "Codes uniques enregistrés avec succès",
      enterEmail: "Entrez votre adresse courriel",
      enterDescription: "Entrez la description",
      enterBrokerCodeForBranch: "Entrez le code courtier pour la succursale",
      insurerHeader:
        "Vous pouvez personnaliser les adresses courriels et les noms des assureurs que votre équipe voit lors de l'envoi au marché.",
      topAdminHeader:
        "Personnalisez la présentation des documents pour votre cabinet",
      contactNumber: "Numéro de contact",
      website: "Site web",
      additionalBranches: "Branches supplémentaires",
      invoiceEmails: "E-mails de facturation",
      primaryAddress: "Adresse principale",
      brokerageName: "Nom du cabinet",
      brokerageSummary:
        "Le nom et les coordonnées de votre cabinet apparaîtront sur divers documents. Veuillez vous assurer qu'ils sont exacts et les mettre à jour si nécessaire.",
      contactDetailHeader:
        "Vous pouvez ajouter, suspendre et mettre à jour les coordonnées des utilisateurs de votre cabinet",
      userName: "Nom d'utilisateur",
      admin: "Admin",
      active: "Actif",
      email: "Courriel",
      location: "Adresse",
      action: "Action",
      body: "Corps",
      update: "Mettre à jour",
      yes: "Oui",
      no: "Non",
      contact: "Assureur",
      contactEmail: "Adresse courriel",
      descriptionOrName: "Description",
      default: "Par défaut",
      addInsurerCode: "Ajouter un code d’agence",
      bmsHeader: " Mettre à jour les identifiants BMS",
      bmsSelectText: "Sélectionnez le fournisseur BMS :",
      bmsSelectWorkflow: "Sélectionnez les flux de travail à intégrer",
      bmsCreateProspect: "Créer un nouveau prospect",
      bmsUpdateProspect: "Mettre à jour le prospect",
      bmsUpdateBind: "Mettre à jour lors de la souscription",
      colorEnterHex: "Entrez le code hexadécimal de la couleur",
      colorSelected: "Couleur sélectionnée",
      colortSelect1: "Sélectionnez la couleur n°1",
      colortSelect2: "Sélectionnez la couleur n°2",
      colortSelect3: "Sélectionnez la couleur n°3",
      colorSaveTheme: "Enregistrer le thème",
      colorAddLogo: "Ajouter un logo",
      colorImagePreview: "Aperçu de l'image",
      colorUpload: "Télécharger",
      colorCurrentLogo: "Logo actuel",
      colorNoLogo: "Aucun logo enregistré.",
      aboutUsHeader:
        "Vous pouvez ajouter, suspendre et mettre à jour la section À propos de nous dans votre cabinet",
      aboutUsTitleName: "Nom du titre",
      aboutUsAddButton: "Ajouter nouveau à propos de nous",
      transactionListTitle: "Liste des transactions",
      subscriptionName: "Nom de l'abonnement",
      subscriptionPrice: "Prix de l'abonnement",
      tax: "Taxe",
      date: "Date",
      totalAmount: "Montant total",
      view: "Voir",
      noData: "-",
      loading: "Chargement...",
      noTransactions: "Aucune transaction trouvée.",
      infoText:
        "Vous pouvez ajouter, suspendre et mettre à jour les coordonnées pour l'équipe utilisateur de votre cabinet",
      tableHeaderTitle: "Titre",
      tableHeaderAction: "Action",
      buttonUpdate: "Mettre à jour",
      buttonAddNewGroup: "Ajouter un nouveau groupe",
      noGroupData: "Aucun groupe disponible.",
      addGroupModalTitle: "Ajouter un nouveau groupe",
      updateGroupModalTitle: "Mettre à jour le groupe",
      errorLoading: "Erreur lors du chargement des groupes.",
      brokerageDetails: "Détails du cabinet",
      userManagement: "Gestion des utilisateurs",
      insurerContacts: "Gestion des assureurs",
      bmsCredentials: "Identifiants BMS",
      logoAndColors: "Logo et couleurs",
      aboutUs: "À propos de nous",
      payment: "Paiement",
      transaction: "Transaction",
      groupManagement: "Gestion de groupe",
      quoteyDashboard: "Tableau de bord Quotey",
      authManagement: "Gestion d'authentification",
      subscribeNow: "Souscrire maintenant",
      paymentConfirmation: "Confirmation de paiement",
      paymentDescription:
        "Votre carte de crédit sera débitée aujourd'hui de 100 $. Cela vous donne une licence pour ajouter jusqu'à 10 utilisateurs à votre cabinet. Des utilisateurs supplémentaires peuvent être ajoutés au coût de 10 $ par utilisateur supplémentaire à chaque période de paiement (qui s'accumulera dans les futures périodes de paiement). Votre carte de crédit sera automatiquement débitée tous les 30 jours pour une utilisation continue de Quotey, le montant facturé sera de 100 $ pour jusqu'à 10 utilisateurs plus 10 $ par utilisateur supplémentaire. Le nombre d'utilisateurs de votre cabinet sera calculé en fonction du nombre",
      cardDetails: "Détails de la carte",
      addNewCardTitle: "Ajouter une nouvelle carte",
      cardsListTitle: "Liste des cartes",
      errorProcessingPayment:
        "Une erreur s'est produite lors du traitement de votre paiement.",
      addCard: "Ajouter une carte",
      addNewUser: "Ajouter un nouvel utilisateur",
      addAnotherBranch: "Ajouter une autre succursale",
      addMore: "Ajouter plus",
      address1: "Adresse 1",
      address2: "Adresse 2",
      city: "Ville",
      province: "Province",
      postalCode: "Code postal",
      save: "Enregistrer",
      fromHereCustomizeDetails:
        "À partir d'ici, vous pouvez personnaliser les détails de votre certificat.",
      certificateHolderInformation:
        "Informations sur le titulaire du certificat",
      certificateHolderName: "Nom du titulaire du certificat",
      addressLine1: "Adresse Ligne 1",
      addressLine2: "Adresse Ligne 2",
      townCity: "Ville",
      numberOfDaysNoticeRequiredQuestion: "Nombre de jours de préavis requis ?",
      numberOfDaysNoticeRequired: "Nombre de jours de préavis requis",
      lossPayeeOrAdditionalInsuredQuestion:
        "Cette personne ou entité est-elle également bénéficiaire en cas de sinistre ou assuré supplémentaire ?",
      selectYourOption: "Sélectionnez votre option",
      lossPayee: "Bénéficiaire en cas de sinistre",
      additionalInsured: "Assuré supplémentaire",
      natureOfInterest: "Nature de l'intérêt",
      locationOfInterest: "Lieu d'intérêt",
      waiverOfSubrogationRequiredQuestion:
        "Une renonciation à la subrogation est-elle requise ?",
      crossLiabilityClauseRequiredQuestion:
        "Une clause de responsabilité croisée est-elle requise ?",
      enterInsurerContactDetailFor:
        "Entrez les détails du contact assureur pour",
      description: "Description",
      makeDefault: "Définir par défaut",
      add: "Ajouter",
      cancel: "Annuler",
      enterYourBrokerageCodesFor: "Entrez vos codes d’agence pour",
      brokerCode1: "Code d’agence 1",
      brokerCode2: "Code d’agence 2",
      brokerCode3: "Code d’agence 3",
      enterBrokerCode1: "Entrez le Code d’agence 1",
      enterBrokerCode2: "Entrez le Code d’agence 2",
      enterBrokerCode3: "Entrez le Code d’agence 3",
      masterCode: "Code Principal",
      enterDefaultCode: "Entrez le Code par Défaut",
      users: "Utilisateurs",
      quoteyUserId: "Identifiant Utilisateur Quotey",
      insurerUserId: "Identifiant Utilisateur Assureur",
      insurerPassword: "Mot de Passe Assureur",
      uniqueCodesSavedSuccessfully: "Codes uniques enregistrés avec succès",
      addedContactSuccessfully: "Contact ajouté avec succès",
      defaultUpdatedSuccessfully: "Par défaut mis à jour avec succès",
      contactDeletedSuccessfully: "Contact supprimé avec succès",

      insurerPasswordPlaceholder: "Entrez le mot de passe de l'assureur",
      startApplicationFullAppMode: "Démarrer en mode application complète",
      themeSavedSuccessfully: "Thème enregistré avec succès",
      logoSavedSuccessfully: "Logo enregistré avec succès",
    },
    newProspectPopover: {
      whichProductQuestion: "Pour quel produit souhaitez-vous créer une demande?",
    },
    filterForCovers: "Filtre pour les noms de couverture",
    backToInsurerHub: "Retour au Hub des assureurs",
    viewOffer: "Voir l'offre",
    compareOffer: "Comparer les offres",
    save: "Enregistrer",
    edit: "Modifier",
    pleaseShareWithClient: "Veuillez partager le lien ci-dessus avec le client",
    optionsToInclude: "Options à inclure",
    fromOperations: " de l'opération",
    backToApplication: "Retour page d’accueil",
    backToProspect: "Retour aux prospects",
    review: "Revoir",
    showMore: "Afficher plus",
    recentProspects: " Soumissions récentes",
    whatTypeOfBusiness:
      "Quel type d’entreprise désirez-vous coter aujourd’hui ?​",
    splitByWork: "Répartir par travail",
    revenuePercentage: "Pourcentage de revenus",
    add: "Ajouter", // French translation
    operation: "Opération", // French translation
    addNewOperation: "Ajouter une nouvelle opération ?",
    selectOne: "Sélectionner un",
    selectMultiple: "Sélectionner plusieurs",
    address: {
      autofill: "Remplissage automatique par une seule recherche...",
      correspondenceLine1: "Ligne 1",
      correspondenceLine2: "Ligne 2",
      city: "Ville",
      province: "Province",
      country: "Pays",
      postalCode: "Code postal",
      noOptions: "Aucune option",
    },
    enterNumber: "Nombre",
    locationNumber: "Emplacement #",
    dragAndDrop:
      "Faites glisser et déposez quelques fichiers ici, ou cliquez pour sélectionner des fichiers",
    yes: "Oui",
    no: "Non",
    scratchpad: "Bloc-notes pour le courtier",
    helpOrTip: "Aide ou Astuce",
    helpOrTipFromQuotey: "Aide et conseil de Quotey",
    next: "SUIVANT",
    previous: "PRÉCÉDENT",
    yourBrokerInfo: "Vos informations de cabinet",
    imDoneAnswering: "J'ai fini de répondre",
    handOffToClient: "Transférer au client",
    goToMarket: "Mise en marché",
    backToHomePage: "Retour page d'accueil",
    goBackToCustomer: "Retour au client",
    prospectsHeader: "Vos clients potentiels",
    prospectsSubHeader:
      "Utiliser le filtre ou sélectionner une page ci-dessous pour voir tous vos clients.",

    sendToInsurers: "Envoyer aux Assureurs",
    insurersMatch:
      "Ces assureurs sont recommandés comme correspondance potentielle pour votre client.",
    digitalMarketingHub: "Plate-forme numérique",
    for: "pour",
    digitalHubDescription:
      "Dans le centre de marketing numérique, vous verrez automatiquement les réponses des assureurs participants et pourrez également suivre les réponses d'autres marchés.",
    insurer: "Assureur",
    product: "Produit",
    recommendedscore: "Score Quotey",
    price: "Prix",
    coveragelevel: "Pourcentage de couverture",
    rateit: "Donner une note",
    stars: "étoiles",
    basedOn: "basées sur",
    reviewsText: "avis",
    type: "Type",
    contact: "Contact",
    review: "Réviser",
    search: "Rechercher",
    binderTitle: "Mes certificats",
    welcomeBack: "Bienvenue,",
    binderSubInfo:
      "Utiliser le filtre ou sélectionner une page ci-dessous pour voir tous vos clients.",

    externalLink: {
      text: "Créez et copiez un lien que vous pouvez envoyer aux assureurs, leur offrant une vue non modifiable de la demande du client dans Quotey",
      buttonText: "Obtenir le lien externe vers les écrans Quotey",
    },
    sendToSelectedInsurers: "Envoyer aux assureurs sélectionnés",
    createEmailWithApplication: "Créer un email avec la demande",
    downloadPDF: {
      text: "Télécharger un PDF contenant toutes les questions et réponses de la proposition d'assurance",
      buttonText: "PDF de la proposition d'assurance",
    },
    editPDFOptions: "Modifier les options PDF",
    downloadPDFButtonText: "Télécharger le PDF",

    // **New Translations for Column Headings**
    columnHeadingsQuotes: {
      first: "Courtier",
      second: "Client",
      third: "Secteur d’activités​",
      fourth: "Nom du contact",
      fifth: "Numéro de Contact",
      sixth: "Courriel du contact",
      seventh: "Statut",
      eighth: "Dernière Mise à Jour",
      ninth: "Réviser les détails",
    },

    // **New Translations for Paragraph**
    processParagraph: "Voici le processus :", // Adjust as per French norms

    // **New Translations for Forms and Labels**
    form: {
      generalBindInformation: "Informations Générales de Liaison",
      financials: "Financiers",
      insurerLabel: "Assureur *",
      bindNumberLabel: "Numéro de Liaison",
      quoteReferenceLabel: "Référence de Devis *",
      effectiveDateLabel: "Date effective *",
      expiryDateLabel: "Date d'Expiration *",
      paymentMethodLabel: "Méthode de Paiement *",
      premiumLabel: "Prime *",
      insurerFeesLabel: "Frais de l'Assureur *",
      brokerFeesLabel: "Frais de Courtier",
      premiumAndFeesLabel: "Prime & Frais *",
      taxRateApplicableLabel: "Taux de taxe applicable (%)",
      taxesPayableLabel: "Taxes Payables",
      commissionRateLabel: "Taux de Commission (%)",
      commissionEarnedLabel: "Commission Gagnée",
      selectPaymentMethodPlaceholder: "Sélectionnez une méthode de paiement",
    },
    filters: {
      header: "Filtres",
      dateHeader: "Date",
      statusHeader: "Statut",
      verticalHeader: "Secteur d’activités",
      brokerHeader: "Courtier",
      searchForClientPlaceholder: "Rechercher un Client",
      clearFiltersButton: "Effacer les Filtres",
    },

    // **Translations for Select Options**
    selectOptions: {
      week: "Semaine",
      month: "Mois",
      year: "Année",
      custom: "Personnalisé",
    },
    operationsBreakDown: {
      totalAnnualRevenues: "Revenus annuels totaux",
      last12Months: "Les 12 derniers mois",
      projected12Months: "12 mois projetés",

      areRevenuesFromCanada: "Tous les revenus sont-ils générés au Canada ?",
      percentageFromCanada: "% du Canada ?",
      percentageFromUSA: "% des États-Unis",
      percentageFromOtherCountries: "% d'autres pays",
      provideSplitByWork: "Fournissez une répartition par travail",
      percentageResidential: "% résidentiel",
      calculationResidential: "A + B / C",
      percentageCommercial: "% commercial",
      percentageIndustrial: "% industriel",
      percentageAgricultural: "% agricole",

      followingIsEqual: "Les éléments suivants doivent être égaux à 100 % ",
      error: "erreur",
    },
    coveragePopOverHeader: "Ajouter des garanties",
    coveragePopOverDescription:"Sélectionnez une ou plusieurs des options de couverture suivantes pour les inclure dans cette demande. Veuillez noter que cela ajoutera des questions à la demande dans des sections que vous avez déjà complétées.",
    paymentProvider: {
      description: "Vous pouvez ajouter des détails de paiement",
      providerName: "Nom du fournisseur de paiement",
      action: "Action",
      addProvider: "Ajouter un fournisseur de paiement",
      updateProvider: "Mettre à jour le fournisseur de paiement",
      premium: "Prime",
      insurerFees: "Frais d'assureur",
      insurerFee: "Frais d'assureur",
      brokerFees: "Frais de courtier",
      brokerFee: "Frais de courtier",
      taxRate: "Taux de taxe",
      taxAmount: "Montant de la taxe",
      totalAmount: "Montant total",
      totalAmountFinanced: "Montant total à financer",
      key: "Clé",
      value: "Valeur",
      type: "Type",
      enterKey: "Entrez la clé",
      enterValue: "Entrez la valeur",
      selectOption: "Sélectionner une option",
      listValue: "Valeur de liste",
      commaInstructions: "Entrez des valeurs séparées par des virgules (ex: valeur1, valeur2, valeur3)",
      enterListValue: "Entrez la valeur de liste",
      delete: "Supprimer",
      addKeyName: "Ajouter le nom de la clé",
      fieldRequired: "Ce champ est requis",
      list: "Liste",
      number: "Nombre",
      text: "Texte",
      date: "Date",
    },

    // SSO Management Translations
    sso: {
      pageTitle: "Gestion de l'authentification unique",
      enableSSO: "Activer l'authentification unique (SSO)",
      completeSAMLConfig: "Compléter la configuration SAML",
      ssoActive: "L'authentification unique est active",
      shareValues: "Partagez ces valeurs avec votre administrateur informatique",
      enterIdpDetails: "Saisissez les détails de configuration de votre IdP",
      configureSSO: "Choisissez comment configurer les paramètres de votre fournisseur d'identité. Vous pouvez utiliser une URL de métadonnées pour la configuration automatique ou saisir les détails manuellement.",
      useMetadataURL: "Utiliser l'URL de métadonnées",
      manualConfiguration: "Configuration manuelle",
      metadataURLSetup: "Configuration URL de métadonnées",
      metadataURLDescription: "Obtenez l'URL de métadonnées de votre fournisseur d'identité (Okta, Azure AD, Google Workspace, etc.). Cette URL se termine généralement par \"/metadata\" et contient toute la configuration SAML requise.",
      idpMetadataURL: "URL de métadonnées du fournisseur d'identité",
      metadataURLPlaceholder: "https://votre-idp.com/app/abc123/sso/saml/metadata",
      metadataURLHelp: "L'URL de métadonnées XML fournie par votre fournisseur d'identité. Cela configurera automatiquement tous les paramètres SAML.",
      configureWithMetadataURL: "Configurer avec l'URL de métadonnées",
      processingMetadata: "Traitement des métadonnées...",
      metadataProcessedSuccessfully: "URL de métadonnées traitée avec succès !",
      extractedConfiguration: "Configuration extraite :",
      ssoURL: "URL SSO",
      entityID: "ID d'entité",
      certificateImported: "Certificat : Importé avec succès",
      refreshStatus: "Actualiser le statut",
      important: "Important",
      nameidFormat: "Format d'ID de nom",
      nameidFormatHelp: "Comment les identités d'utilisateur sont formatées",
      identityProviderConfiguration: "Configuration du fournisseur d'identité",
      connectionInformation: "Informations de connexion",
      status: "Statut",
      active: "ACTIF",
      connectionID: "ID de connexion",
      connectionIDHelp: "ID de référence à des fins de support",
      created: "Créé",
      lastUpdated: "Dernière mise à jour",
      editConfiguration: "Modifier la configuration",
      deleteConnection: "Supprimer la connexion",
      editSAMLConfiguration: "Modifier la configuration SAML",
      cancel: "Annuler",
      saveChanges: "Enregistrer les modifications",
      saving: "Enregistrement...",
      editError: "Erreur de modification :",
      nextSteps: "Prochaines étapes : Partagez l'URL de connexion de votre application avec les membres de l'équipe et informez-les qu'ils peuvent utiliser leurs identifiants d'entreprise pour se connecter.",
      howItWorks: "Comment ça fonctionne : Nous allons créer une connexion SAML sécurisée et vous fournir les détails de configuration dont votre administrateur informatique a besoin pour configurer le SSO dans votre fournisseur d'identité.",
      settingUpSAMLConnection: "Configuration de votre connexion SAML...",
      setupInProgress: "Cela peut prendre un moment. Veuillez ne pas fermer cette page.",
      setupError: "Erreur de configuration :",
      startSSOSetup: "Démarrer la configuration SSO",
      settingUp: "Configuration...",
      configurationError: "Erreur de configuration :",
      activatingSSO: "Activation du SSO...",
      itAdminDescription: "Votre administrateur informatique aura besoin de ces valeurs exactes pour configurer SAML dans votre fournisseur d'identité (Okta, Azure AD, Google Workspace, etc.).",
      emailAttributeWarning: "Assurez-vous que votre administrateur informatique mappe correctement l'attribut email dans votre IdP. Les adresses email des utilisateurs doivent correspondre exactement.",
      idpSSOURL: "URL d'authentification unique IdP",
      fromMetadataURL: "Depuis l'URL de métadonnées",
      extractedFromMetadata: "Extrait de l'URL de métadonnées - configuration terminée",
      ssoURLPlaceholder: "https://votre-idp.com/sso/saml",
      ssoURLHelp: "L'URL vers laquelle les utilisateurs seront redirigés pour se connecter (depuis votre IdP)",
      idpEntityID: "ID d'entité IdP",
      entityIDPlaceholder: "https://votre-idp.com/entity-id",
      entityIDHelp: "Identifiant unique pour votre fournisseur d'identité",
      idpSingleLogoutURL: "URL de déconnexion unique IdP (Optionnel)",
      sloURLPlaceholder: "https://votre-idp.com/slo/saml",
      sloURLHelp: "Optionnel : URL pour la fonctionnalité de déconnexion unique",
      x509Certificate: "Certificat X.509",
      certificateImportedFromMetadata: "Certificat importé avec succès depuis l'URL de métadonnées",
      certificatePlaceholder: "-----BEGIN CERTIFICATE-----\nMIIDXTCCAkWgAwIBAgIJAKoK/heBjcOuMA0GCSqGSIb3DQEBBQUAMEUxCzAJBgNV\n...\n-----END CERTIFICATE-----",
      certificateHelp: "Le certificat X.509 complet de votre IdP (y compris les lignes BEGIN/END)",
      certificateExtractedFromMetadata: "Certificat extrait et importé depuis l'URL de métadonnées - configuration terminée",
      configureAttributeMapping: "Configurer le mappage des attributs",
      requiredToActivate: "Requis pour activer la connexion",
      metadataProcessingComplete: "Traitement des métadonnées terminé ! Configurez maintenant comment les attributs SAML sont mappés aux champs utilisateur pour activer votre connexion.",
      attributeMappingDescription: "Mappez les attributs SAML de votre IdP aux champs utilisateur. Ceux-ci indiquent quels attributs SAML contiennent les informations utilisateur.",
      progressStatus: "Statut de progression :",
      ssoURLExtracted: "URL SSO extraite des métadonnées",
      entityIDExtracted: "ID d'entité extrait des métadonnées",
      certificateImportedFromMetadataStatus: "Certificat importé depuis les métadonnées",
      attributeMappingNeeded: "Mappage des attributs nécessaire pour l'activation",
      commonAttributeNames: "Noms d'attributs communs",
      emailAttributeOptions: "Email : email, EmailAddress, mail",
      firstNameAttributeOptions: "Prénom : firstName, givenName, first_name",
      lastNameAttributeOptions: "Nom : lastName, surname, last_name, sn",
      emailAttributeName: "Nom de l'attribut email",
      emailAttributePlaceholder: "email",
      emailAttributeHelp: "Le nom de l'attribut SAML qui contient l'adresse email de l'utilisateur",
      firstNameAttributeName: "Nom de l'attribut prénom",
      firstNameAttributePlaceholder: "firstName",
      firstNameAttributeHelp: "Le nom de l'attribut SAML qui contient le prénom de l'utilisateur",
      lastNameAttributeName: "Nom de l'attribut nom",
      lastNameAttributePlaceholder: "lastName",
      lastNameAttributeHelp: "Le nom de l'attribut SAML qui contient le nom de famille de l'utilisateur",
      configurationError: "Erreur de configuration :",
      activatingSSO: "Activation du SSO...",
      completeSSOActivation: "Terminer l'activation du SSO",
      activateSingleSignOn: "Activer l'authentification unique",
      loadingSSOConfiguration: "Chargement de la configuration SSO...",
      errorLoadingSSO: "Erreur de chargement du statut SSO :",
      tryAgain: "Réessayer",
      ssoActiveDescription: "Les membres de votre équipe peuvent maintenant se connecter facilement en utilisant le fournisseur d'identité de votre entreprise. Les nouveaux utilisateurs seront automatiquement provisionnés lors de leur première connexion.",
      ssoConfigurationDetails: "Détails de configuration SSO",
      serviceProviderDetails: "Détails du fournisseur de services",
      singleSignOnURL: "URL d'authentification unique (URL ACS)",
      acsURLHelp: "Où votre IdP envoie les réponses SAML",
      audienceURI: "URI d'audience (ID d'entité SP)",
      audienceURIHelp: "Identifiant unique pour votre application",
      nameIDFormat: "Format de l'ID de nom",
      nameIDFormatHelp: "Comment les identités utilisateur sont formatées",
      identityProviderConfiguration: "Configuration du fournisseur d'identité",
      idpSSOURLActive: "URL SSO IdP",
      idpSSOURLHelp: "Point de terminaison de connexion de votre fournisseur d'identité",
      idpEntityIDActive: "ID d'entité IdP",
      idpEntityIDActiveHelp: "Identifiant unique de votre fournisseur d'identité",
      certificateMasked: "Certificat (Masqué)",
      certificateVerificationHelp: "Certificat X.509 pour la vérification de signature",
      attributeMappings: "Mappages d'attributs",
      defaultMappings: "Mappages par défaut",
      connectionInformation: "Informations de connexion",
      status: "Statut",
      active: "ACTIF",
      connectionID: "ID de connexion",
      connectionIDHelp: "ID de référence pour le support",
      created: "Créé",
      lastUpdated: "Dernière mise à jour",
      editConfiguration: "Modifier la configuration",
      deleteConnection: "Supprimer la connexion",
      editSAMLConfiguration: "Modifier la configuration SAML",
      cancel: "Annuler",
      saving: "Enregistrement...",
      saveChanges: "Enregistrer les modifications",
      nextSteps: "Prochaines étapes : Partagez l'URL de connexion de votre application avec les membres de l'équipe et informez-les qu'ils peuvent utiliser leurs identifiants d'entreprise pour se connecter.",
      howItWorks: "Comment ça marche : Nous créerons une connexion SAML sécurisée et vous fournirons les détails de configuration dont votre administrateur informatique a besoin pour configurer le SSO dans votre fournisseur d'identité.",
      settingUpSAMLConnection: "Configuration de votre connexion SAML...",
      settingUpMessage: "Cela peut prendre un moment. Veuillez ne pas fermer cette page.",
      setupError: "Erreur de configuration :",
      startSSOSetup: "Démarrer la configuration SSO",
      settingUp: "Configuration en cours...",
      deleteSAMLConnection: "Supprimer la connexion SAML",
      deleteSAMLMessage: "Êtes-vous sûr de vouloir supprimer cette connexion SAML ? Cette action désactivera immédiatement l'authentification unique pour votre organisation et ne peut pas être annulée.",
      confirmationText: "supprimer",
      samlConnection: "connexion SAML",

      // Missing Form Labels
      identityProviderMetadataURL: "URL des métadonnées du fournisseur d'identité",
      idpSingleSignOnURL: "URL d'authentification unique IdP",
      idpEntityID: "ID d'entité IdP",
      idpSingleLogoutURL: "URL de déconnexion unique IdP (Optionnel)",
      x509Certificate: "Certificat X.509",

      // Status Messages
      metadataURLProcessedSuccessfully: "URL des métadonnées traitée avec succès !",
      extractedConfiguration: "Configuration extraite :",
      ssoURL: "URL SSO :",
      entityID: "ID d'entité :",
      certificateImportedSuccessfully: "Certificat : Importé avec succès",
      editError: "Erreur de modification :",

      // Success Messages
      fromMetadataURL: "Depuis l'URL des métadonnées",
      certificateImportedFromMetadata: "Certificat importé avec succès depuis l'URL des métadonnées",
      extractedFromMetadataComplete: "Extrait de l'URL des métadonnées - configuration terminée ✅",
      metadataProcessingComplete: "Traitement des métadonnées terminé ! Configurez maintenant comment les attributs SAML correspondent aux champs utilisateur pour activer votre connexion.",
      attributeMappingNeeded: "Mappage des attributs nécessaire pour l'activation",

      // Button Text
      configureWithMetadataURL: "Configurer avec l'URL des métadonnées",
      processingMetadata: "Traitement des métadonnées...",

      // Placeholders
      metadataURLPlaceholder: "https://votre-idp.com/app/abc123/sso/saml/metadata",
      ssoURLPlaceholder: "https://votre-idp.com/sso/saml",
      entityIDPlaceholder: "https://votre-idp.com/entity-id",
      sloURLPlaceholder: "https://votre-idp.com/slo/saml",
      sloURLPlaceholderOptional: "https://votre-idp.com/slo/saml (optionnel)",

      // Help Text
      idpSsoURLHelp: "L'URL vers laquelle les utilisateurs seront redirigés pour se connecter (depuis votre IdP)",
      idpEntityIDHelp: "Identifiant unique pour votre fournisseur d'identité",
      x509CertificateHelp: "Le certificat X.509 complet de votre IdP (y compris les lignes BEGIN/END)",
      certificateExtractedFromMetadata: "Certificat extrait et importé depuis l'URL des métadonnées - configuration terminée ✅",
      attributeMappingDescription: "Mappez les attributs SAML de votre IdP aux champs utilisateur. Ceux-ci indiquent quels attributs SAML contiennent les informations utilisateur.",

      // Section Headers
      serviceProviderDetails: "Détails du fournisseur de services",
      identityProviderConfiguration: "Configuration du fournisseur d'identité",
      singleSignOnURLACS: "URL d'authentification unique (URL ACS)",
      audienceURISPEntityID: "URI d'audience (ID d'entité SP)",

      // Common Attribute Names
      commonAttributeNames: "Noms d'attributs communs",
      commonAttributeNamesTitle: "Noms d'attributs communs :",
      emailAttributeOptions: "Email : email, EmailAddress, mail",
      firstNameAttributeOptions: "Prénom : firstName, givenName, first_name",
      lastNameAttributeOptions: "Nom : lastName, surname, last_name, sn",

      // Additional Labels
      nameIDFormat: "Format de l'ID de nom",
      uniqueIdentifierForApplication: "Identifiant unique pour votre application",
      howUserIdentitiesFormatted: "Comment les identités utilisateur sont formatées",

      // Missing translations for comprehensive localization
      copied: "Copié !",
      copy: "Copier",
      status: "Statut",
      active: "ACTIF",
      attributeMappings: "Mappages d'attributs",
      certificateMasked: "Certificat (Masqué)",
      enableSingleSignOn: "Activer l'authentification unique (SSO)",
      allowYourTeam: "Permettez à votre équipe de se connecter facilement en utilisant le fournisseur d'identité de votre entreprise comme Okta, Azure AD, Google Workspace, ou tout système compatible SAML.",
      whereYourIdP: "Où votre IdP envoie les réponses SAML",
      yourIdentityProviderSignOn: "Point de connexion de votre fournisseur d'identité",
      yourIdentityProviderUnique: "Identifiant unique de votre fournisseur d'identité",
      x509CertificateSignature: "Certificat X.509 pour la vérification de signature",
      sloURLPlaceholderOptional: "https://votre-idp.com/slo/saml (optionnel)",
      activatingSSO: "Activation du SSO...",
      settingUpSAMLConnectionDots: "Configuration de votre connexion SAML...",
      thisMayTakeAMoment: "Cela peut prendre un moment. Veuillez ne pas fermer cette page.",
      certificateImportedFromMetadataURL: "Certificat importé avec succès depuis l'URL de métadonnées",
      ssoURLExtractedFromMetadata: "URL SSO extraite des métadonnées",
      entityIDExtractedFromMetadata: "ID d'entité extrait des métadonnées",
      certificateImportedFromMetadataStatus: "Certificat importé depuis les métadonnées",
      attributeMappingNeededToActivate: "Mappage des attributs nécessaire pour l'activation"
    },

    // Stytch Organization Management Translations
    stytchOrg: {
      pageTitle: "Paramètres de l'organisation Stytch",
      organizationConfiguration: "Configuration de l'organisation",
      configurationDescription: "Configurez les paramètres de votre organisation Stytch pour contrôler les méthodes d'authentification, les domaines de messagerie et les polices de provisionnement des utilisateurs pour votre application.",
      loadingText: "Chargement des paramètres de l'organisation Stytch...",

      // Basic Information Section
      basicInformation: "Informations de base",
      organizationName: "Nom de l'organisation",
      organizationNamePlaceholder: "Nom de votre entreprise",
      organizationNameHelp: "Le nom d'affichage de votre organisation",
      organizationSlug: "Identifiant de l'organisation",
      organizationSlugPlaceholder: "votre-entreprise",
      organizationSlugHelp: "Identifiant compatible URL (minuscules, sans espaces)",
      organizationLogoURL: "URL du logo de l'organisation",
      organizationLogoURLPlaceholder: "https://votre-entreprise.com/logo.png",
      organizationLogoURLHelp: "Optionnel : URL vers le logo de votre organisation",

      // Email Configuration Section
      emailConfiguration: "Configuration des e-mails",
      allowedEmailDomains: "Domaines de messagerie autorisés",
      noDomains: "Aucun domaine ajouté",
      addDomain: "Ajouter un domaine",
      removeDomain: "Supprimer",
      emailDomainsHelp: "Les utilisateurs ne peuvent s'inscrire qu'avec des adresses e-mail de ces domaines",
      emailInvites: "Invitations par e-mail",
      emailInvitesHelp: "Contrôler qui peut envoyer des invitations par e-mail",
      emailJITProvisioning: "Provisionnement JIT par e-mail",
      emailJITProvisioningHelp: "Créer automatiquement des comptes pour les utilisateurs par e-mail (Note : ALL_ALLOWED n'est pas pris en charge)",

      // Authentication & Security Section
      authenticationAndSecurity: "Authentification et sécurité",
      authenticationMethods: "Méthodes d'authentification",
      authenticationMethodsHelp: "Quelles méthodes d'authentification sont autorisées",
      mfaPolicy: "Politique MFA",
      mfaPolicyHelp: "Exigence d'authentification multi-facteurs",
      mfaMethods: "Méthodes MFA",
      mfaMethodsHelp: "Quelles méthodes MFA sont disponibles",

      // SSO Configuration Section
      ssoConfiguration: "Configuration SSO",
      ssoJITProvisioning: "Provisionnement JIT SSO",
      ssoJITProvisioningHelp: "Créer automatiquement des comptes pour les utilisateurs SSO",

      // Dropdown Options
      allAllowed: "Tout autorisé",
      restricted: "Restreint",
      notAllowed: "Non autorisé",
      optional: "Optionnel",
      requiredForAll: "Requis pour tous",

      // Buttons and Actions
      saveOrganizationSettings: "Enregistrer les paramètres de l'organisation",
      updatingSettings: "Mise à jour des paramètres...",

      // Messages
      errorLabel: "Erreur :",
      successLabel: "Succès !",
      successMessage: "Les paramètres de l'organisation ont été mis à jour.",

      // Members Management Section
      organizationMembers: "Membres de l'organisation",
      membersDescription: "Gérer les membres de l'organisation et envoyer des invitations aux nouveaux utilisateurs.",
      inviteNewMember: "Inviter un nouveau membre",
      sendInvitation: "Envoyer l'invitation",
      sendingInvitation: "Envoi en cours...",
      invitationHelp: "Entrez une adresse e-mail pour envoyer une invitation à l'organisation",
      currentMembers: "Membres actuels",
      refresh: "Actualiser",
      loadingMembers: "Chargement des membres...",
      noMembers: "Aucun membre trouvé. Invitez votre premier membre ci-dessus !",
      joined: "Rejoint le :",
      invitationPending: "Invitation en attente",
      inviteSuccessMessage: "L'invitation de membre a été envoyée.",

      // Placeholders
      domainPlaceholder: "exemple.com",
      memberEmailPlaceholder: "membre@exemple.com"
    },

    sendToInsurersRight:{
      appToMarket:"Envoi de votre application sur le marché",
      subHeading:"Quotey transmettra automatiquement votre demande aux assureurs suivants à ces adresses. Vous en recevrez également une copie.",
      editEmailsBtn:"Modifier les e-mails",
      doneEditEmailBtn:"Modification terminée",
      fileUploadHeading:"Autres fichiers à télécharger et à envoyer à l'assureur",
      noDocumentMsg:"Aucun document téléchargé",
      searchByFile:"Rechercher par nom de fichier",
      uploadOtherBtn:"Télécharger autre",
      applicationOptions:"Options PDF de candidature",
      displayTableOfContents:"Afficher la table des matières",
      includeQuestions:"Inclure les questions sans réponse",
      pdfInFrench:"Afficher le PDF en français",
      commentHeading:"Souhaitez-vous fournir des informations supplémentaires à l'assureur avec cette demande ?",
      addText:"Ajouter du texte...",
      sendNowBtn:"Envoyer maintenant",
      noEmailProvided:"Aucun email fourni"
    },

    aiRecommendationModel: {
      loadingContinueButtonText: "Généré...",
      loadingText: "Chargement du texte généré.",
      inputPlaceholder:
        "Présentez ici la recommandation telle qu'elle serait formatée et ajoutée au document PDF de présentation client. Il peut s'agir d'une recommandation de plusieurs pages contenant beaucoup de contenu.",
      modelTitle: "Recommandation du client IA",
      heading1:
        "Sur la base des informations fournies concernant le client, les conditions de couverture expirantes ou demandées et les prix disponibles, Quotey (utilisant l'IA) propose la recommandation suivante qui peut être fournie au client.",
      heading2:
        "Étant donné la nature évolutive de l'IA, il est important pour vous de revoir cette recommandation avant qu'elle ne soit fournie au client pour garantir son exactitude. Vous pouvez modifier et mettre à jour la recommandation si nécessaire.",
      recommendedOptionHeading:
        "Y a-t-il un assureur spécifique autour duquel vous souhaitez que Quotey construise une recommandation ?",
      recommendedOptions: {
        yes: "Oui",
        no: "Non",
      },
      insurerRecommend: "Quel assureur souhaitez-vous recommander ?",
      reasonPlaceHolder: "*Indiquez les raisons de la recommandation...",
      continueButton: "Continuer avec la recommandation de l'IA",
      modelSubmitButton: "Confirmer et enregistrer",
      quoteyRecommendation: "Recommandation de l'IA de Quotey",
      errorMessages: {
        radioSelection: "Veuillez sélectionner Oui ou Non",
        insurerRequired: "Veuillez sélectionner un assureur",
        reasonError: "Veuillez fournir une raison pour la recommandation",
      },
      regenerateButton: "Régénérer",
    },

    quoteAnalysis: {
      quoteAnalysis: "Analyse des devis",
      backToDMH: "Retour au pôle marketing numérique",
      dataInputs: "Entrées de données",
      projections: "Projections",
      likeForLikeQuotes: "Citations du genre 'j'aime pour j'aime",
      insights: "Connaissances",
      recommendation: "Recommandation",
      dataInputsHeading: "Principaux éléments d'analyse et de projection",
      dataInputsSubHeading:
        "Ces données sont essentielles pour garantir la comparaison des devis sur une base comparable et l'exactitude des projections sur trois ans. Veuillez les modifier si nécessaire.",
      saveAllBtn: "Enregistrer tout",
      saveBtn: "Enregistrer",
      nextBtn: "Suivante",
      previousBtn: "Perméable",
      projectionHeading: "Projections sur trois ans",
      noProjection: "Aucune donnée de projection disponible",
      projectionSubHeading:
        "Sur la base des données saisies, voici les coûts projetés sur trois ans pour ce groupe.",
      aiInsights: "Informations sur l'IA",
      generateAIData: "Générer des données IA",
      reGenerateAIData: "Régénérer les données de l'IA",
      likeForLikeSubHeading:
        "Sur la base des données saisies, voici une vue comparable des devis reçus.",
      benefits: "Avantages",
      premium: "Prime",
    },

    coveragePopOverHeader: "Ajouter des garanties",
    coveragePopOverDescription:
      "Sélectionnez une ou plusieurs des options de couverture suivantes pour les inclure dans cette demande. Veuillez noter que cela ajoutera des questions à la demande dans des sections que vous avez déjà complétées.",

    // Grid/Dropdown Toggle
    selectFromDropdown: "Sélectionner dans le menu déroulant",
    selectFromGrid: "Sélectionner dans la grille",
  },
};

export default translations;
